export const electionAuthorityData = {
  sys: { type: 'Array' },
  total: 12,
  skip: 0,
  limit: 1,
  items: [
    {
      sys: {
        space: { sys: { type: 'Link', linkType: 'Space', id: 'ukfvfuufm9k8' } },
        id: '1qyI1lmgovJbRXTEuKaycg',
        type: 'Entry',
        createdAt: '2019-12-11T18:07:32.200Z',
        updatedAt: '2019-12-11T18:07:32.200Z',
        environment: {
          sys: { id: 'development', type: 'Link', linkType: 'Environment' },
        },
        revision: 1,
        contentType: {
          sys: { type: 'Link', linkType: 'ContentType', id: 'democracyWorks' },
        },
        locale: 'en-US',
      },
      fields: {
        endpoint: '/election-authorities/states',
        data: {
          authorities: [
            {
              id: '57ed552e-a6d2-41fe-b31d-64e313df2c4c',
              phone: '(304) 558-6000',
              'office-name': 'West Virginia',
              'homepage-url': 'https://sos.wv.gov/elections/Pages/default.aspx',
              'ocd-division': [
                'ocd-division/country:us/state:wv',
                'West Virginia',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will need to show a valid and non-expired ID to vote in West Virginia. Acceptable forms include: voter registration card; WV driver's license or other WV ID issued by the DMV; driver's license issued by another state; US passport or passport card; Military ID card issued by the US government; US or WV government employee ID; Student ID; concealed carry permit; bank or debit card; utility bill or bank statement issued within 6 months of the date of the election; health insurance card; Medicare card; Social Security card; birth certificate; WV hunting or fishing license; or other current government document that shows your name.\n\nIf you're a first-time voter who registered to vote by mail, you'll need to show proof of residence to vote. Acceptable forms include: photo ID; or a current utility bill, bank statement, government check, paycheck, or other current government document that shows your name and address.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot. You may be able to vote a regular ballot if: a poll worker has known you for at least six months prior to the election; an adult accompanying you signs an affidavit certifying your identity; or you are a resident of a licensed state care facility and your polling place is in that facility.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': true,
                      'acceptable-forms': [{ name: 'wv_absentee' }],
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      url: 'https://ovr.sos.wv.gov/Register/Landing#Qualifications',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a West Virginia ID and a Social Security number to use West Virginia's online voter registration system. If you don't have a West Virginia-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          'Enter your WV driver’s license or DMV-issued non-driver’s ID number. If you do not have a WV driver’s license or DMV-issued ID, enter the last four digits of your social security number. If you do not have a driver’s license, DMV ID or a social security number, enter the word “NONE”. An ID number will be assigned to you.',
                        signature:
                          'To register in West Virginia you must: \nbe a citizen of the United States \nlive in West Virginia at the address on your application \nbe 18 years old, or to vote in the primary be 17 years old and turning 18 before the general election \nnot be under conviction, probation, or parole for a felony, treason or election bribery \nnot have been judged "mentally incompetent" in a court of competent jurisdiction',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://services.sos.wv.gov/Elections/Voter/AmIRegisteredToVote',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mC53JN',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '25305',
                city: 'Charleston',
                state: 'WV',
                street: 'Bldg. 1, Suite 157-K, 1900 Kanawha Blvd. East',
                'routing-code': '25305',
              },
              'polling-place-url':
                'https://services.sos.wv.gov/Elections/Voter/FindMyPollingPlace',
              'polling-place-url-shortened': 'https://tvote.org/2mjCzTj',
              'local-reg-authority-lookup-url':
                'https://sos.wv.gov/elections/Pages/CountyClerkDirectory.aspx',
              'local-election-authority-lookup-url':
                'https://sos.wv.gov/elections/Pages/CountyClerkDirectory.aspx',
            },
            {
              id: '57ed552b-f164-4959-863f-936662d7ec30',
              email: 'sos@ks.gov',
              phone: '785-296-4561',
              'office-name': 'Kansas',
              'homepage-url': 'https://www.kssos.org/elections/elections.html',
              'ocd-division': [
                'ocd-division/country:us/state:ks',
                'Kansas',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will need to show photo ID to vote in Kansas. Acceptable forms include: a driver's license or non-driver's ID card issued by Kansas or by another state; a concealed carry handgun license; US passport; government employee badge or ID; military ID; student ID from an accredited postsecondary institution of education in Kansas; government-issued public assistance ID; or Indian tribal ID. Persons age 65 or older may use expired photo ID documents. \n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot and provide your ID to the county prior to the county canvass (7-10 days after the election) in order for it to be counted.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      instructions: {
                        'voting-id':
                          "If you do not have a current and valid Kansas driver's license number or Kansas non-driver's identification card number, you must provide a copy of one of the following forms of photo identification with this application in order to receive a ballot: Driver's license issued by Kansas or another state; non-driver's ID card issued by Kansas or another state; U.S. passport; Concealed carry of handgun license issued by Kansas or another state; Employee badge or ID document issued by a government office; U.S. military ID; Student ID card issued by an accredited Kansas postsecondary educational institution; Public assistance ID card issued by a government office; or ID card issued by an Indian tribe.",
                      },
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'ks_absentee' }],
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "Your completed voter registration form must contain your Kansas-issued driver's license number or non-driver's identification card number. If you do not have a driver's license or non-driver's identification card, you must include the last four digits of your Social Security number. If you do not have a driver's license or a non-driver's identification card or Social Security number, please write \"NONE\" on the form. A unique identifying number will be assigned by the State. The number you provide will be used for administrative purposes only and will not be disclosed to the public (KSA 25-2309).",
                        signature:
                          'To register in Kansas you must:\nbe a citizen of the United States\nbe a resident of Kansas\nbe 18 by the next election\nhave completed the terms of your sentence if convicted of a felony; a person serving a sentence for a felony conviction is ineligible to vote\nnot claim the right to vote in any other location or under any other name\nnot be excluded from voting by a court of competent jurisdiction',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    {
                      url: 'https://www.kdor.ks.gov/Apps/VoterReg/Default.aspx',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Kansas ID to use Kansas's online voter registration system. If you don't have a Kansas-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://myvoteinfo.voteks.org/VoterView/RegistrantSearch.do',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mC1JOP',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '66612',
                city: 'Topeka',
                state: 'KS',
                street: 'Memorial Hall, 1st Floor, 120 SW 10th Avenue',
                'routing-code': '66612',
              },
              'polling-place-url':
                'https://myvoteinfo.voteks.org/VoterView/PollingPlaceSearch.do',
              'polling-place-url-shortened': 'https://tvote.org/2lZdBXv',
              'local-reg-authority-lookup-url':
                'https://www.kssos.org/elections/elections_registration_ceo.asp',
              'local-election-authority-lookup-url':
                'https://www.kssos.org/elections/elections_registration_ceo.asp',
            },
            {
              id: '57ed552c-7a10-4914-bf73-1328f7586a7e',
              phone: '601-359-5075',
              'office-name': 'Mississippi',
              'homepage-url': 'https://www.sos.ms.gov/Vote/Pages/default.aspx',
              'ocd-division': [
                'ocd-division/country:us/state:ms',
                'Mississippi',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will be asked to show photo ID to vote in Mississippi. Acceptable forms include: Mississippi driver's license or state ID card; US passport; employee ID card issued by any agency of the US government, State of Mississippi, or local government unit in Mississippi; firearms license; student photo ID issued by an accredited Mississippi university, college, or community/junior college; US military ID; a tribal photo ID; photo ID issued by any branch, department, agency or entity of the United States government or any State government; or a Mississippi voter ID card.\n\nVoters without ID: If you do not have an accepted form of photo ID, you can vote an affidavit ballot. The voter will then have five (5) business days to show an acceptable form of photo ID, or apply for a Mississippi Voter ID Card, at the Circuit Clerk’s Office.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': true,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "You are required to provide your current and valid driver's license number or, if you don't have one, the last four digits of your Social Security number.",
                        signature:
                          'To register in Mississippi you must: \nbe a citizen of the United States \nhave lived in Mississippi and in your county (and city, if applicable) 30 days before the election in which you want to vote \nbe 18 years old by the time of the general election in which you want to vote \nhave not been convicted of murder, rape, bribery, theft, arson, obtaining money or goods under false pretense, perjury, forgery, embezzlement, armed robbery, extortion, felony bad check, felony shoplifting, larceny, receiving stolen property, robbery, timber larceny, unlawful taking of a motor vehicle, statutory rape, carjacking, or bigamy, or you have had your rights restored as required by law \nnot have been declared mentally incompetent by a court',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://www.msegov.com/sos/voter_registration/AmIRegistered',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2HFIKeU',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '39201',
                city: 'Jackson',
                state: 'MS',
                street: '125 S. Congress Street',
                'routing-code': '39201',
              },
              'polling-place-url':
                'http://www.sos.ms.gov/pollingplace/Pages/default.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2HulH9m',
              'local-reg-authority-lookup-url':
                'http://www.sos.ms.gov/Elections-Voting/Pages/County-Election-Info.aspx',
              'local-election-authority-lookup-url':
                'http://www.sos.ms.gov/Elections-Voting/Pages/County-Election-Info.aspx',
            },
            {
              id: '57ed552a-438c-43d0-8223-ec5637eb5b9c',
              email: 'director@dcboee.org',
              phone: '(202) 727-2525',
              types: ['election', 'registration'],
              'office-name': 'The District of Columbia',
              'homepage-url': 'https://www.dcboe.org/',
              'ocd-division': [
                'ocd-division/country:us/district:dc',
                'District of Columbia',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "If you've voted in DC before, you don't need to provide ID to vote. Some polling locations may require ID for you to enter the facility, however.\n\nIf you're a first-time voter who registered by mail, and didn't provide proof of residence when registering, you will need to show proof of residence to vote. Acceptable forms include: a current and valid government-issued photo ID; or a current utility bill (including a cell phone bill), bank statement, government check, paycheck, lease or rental agreement, university housing or tuition bill, or another government document that shows your name and address.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a special ballot. You have two days following the election to show ID to the Board of Elections.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      instructions: {
                        'voting-id':
                          "You do not need to provide ID if you have already voted in DC at least once.  If you are voting for the first time in DC, you registered to vote by mail, and you did not provide identification at the time of registration, you must include a copy of your ID with your absentee ballot application.  The following are acceptable forms of identification: a copy of a current driver's license or other photo identification which shows the voter's name and address, or a copy of a utility bill, bank statement, government check, paycheck, or government document which shows the voter's name and address.",
                      },
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'dc_absentee' }],
                    },
                  ],
                  'election-authority-level': 'state',
                  'voter-registration-methods': [
                    {
                      url: 'https://www.vote4dc.com/ApplyInstructions/Register',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a DC-issued driver's license or a mobile device to use the DC online voter registration system. Your registration can include your license number or a digital signature, or you can register to vote by mail.",
                      },
                      'supports-iframe': true,
                    },
                    { type: 'election-day' },
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "Federal law now requires that all voter registration applications must include either the applicant's driver's license number or the last four digits of the applicant's Social Security number in order to be processed.",
                        signature:
                          'To vote in the District of Columbia you must: \nbe a citizen of the United States \nbe a be a resident of the District of Columbia\nmaintain residency in the District of Columbia for at least 30 days prior to the election in which you intend to vote \nnot claim voting residence or the right to vote in another U.S. state or territory\nbe at least 17 years old (You may register to vote if you are at least 16 years old. You may vote in a primary election if you are at least 17 years old and you will be at least 18 years old by the next general election. You may vote in a general or special election if you are at least 18 years old).\nnot be in jail for a felony conviction \nnot have been found by a court to be legally incompetent to vote',
                        'citizenship-docs':
                          'When registering for the first time by mail you will need to include a copy of one of the following: a current and valid government photo identification; a current utility bill; a current bank statement; a current government check; a paycheck; or other government document that shows the name and address of the voter.',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://www.dcboe.org/Voters/Register-To-Vote/Check-Voter-Registration-Status',
                  'voter-registration-authority-level': 'state',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2Hxg761',
                },
              ],
              'official-title': 'Board of Elections',
              'physical-address': {
                zip: '20003',
                city: 'Washington',
                state: 'DC',
                street: '1015 Half Street SE Suite 750',
                'routing-code': '20003',
              },
              'polling-place-url':
                'https://dcboe.org/Voters/Where-to-Vote/Polling-Places',
              'polling-place-url-shortened': 'https://tvote.org/2QqMm7W',
              'local-reg-authority-lookup-url':
                'https://www.vote4dc.com/ApplyInstructions/Register',
              'local-election-authority-lookup-url': 'https://www.dcboe.org/',
            },
            {
              id: '57ed552c-d9e0-4980-907e-9095ecb2d308',
              email: 'info@sos.mo.gov',
              phone: '(573) 751-4936',
              'office-name': 'Missouri',
              'homepage-url': 'https://www.sos.mo.gov/elections/',
              'ocd-division': [
                'ocd-division/country:us/state:mo',
                'Missouri',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: false,
                      instructions: {
                        'voting-id':
                          "Voters requesting an absentee ballot by mail who have registered by mail and have not voted in person are required to submit a copy of their personal identification unless they provided a copy with their registration application. \n\nExamples of acceptable identification are: ID issued by the state of Missouri, an agency of the state, or a local election authority of the state; ID issued by the United States government or agency thereof; ID issued by an institution of higher education, including a university, college, vocational and technical school, located within the state of Missouri; copy of a current utility bill, bank statement, government check, paycheck or other government document that contains the name and address of the voter; Driver's license or state ID card issued by another state; or other ID approved by the secretary of state under rules promulgated pursuant to subsection 3 of this section other identification approved by federal law.\n\nThis identification requirement, as well as the notary requirement for absentee ballots, does not apply to overseas voters, those on active military duty or members of their immediate family living with them or voters who are permanently disabled and their caregivers.",
                      },
                      'excuse-required': true,
                      'acceptable-forms': [{ name: 'mo_absentee' }],
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will be asked to show ID to vote in Missouri. Acceptable forms of government-issued photo ID include: a driver's license; non-driver's license; US passport; or military ID. If you do not have a government-issued photo ID, you can also show one of the following forms of ID: a voter registration card; ID from a Missouri university, college, vocational or technical school; a copy of a current utility bill, bank statement, paycheck, government check or other government document that contains your name and address.\n\nVoters without ID: If you are unable to provide ID, you will be able to cast a provisional ballot. Your ballot will count if your signature matches the signature in the voter registry or if you return to your polling place and show a photo ID.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': ['municipal', 'county'],
                  'voter-registration-methods': [
                    {
                      url: 'https://s1.sos.mo.gov/votemissouri/request',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: Missouri requires that you use a tablet, mobile device, or other touchscreen device to register online to vote. Boone County voters will need to click through to the county's separate registration site.",
                      },
                      'supports-iframe': false,
                    },
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          'Your completed voter registration form must contain your Missouri-issued driver\'s license number. Your completed voter registration form must also include the last four digits of your Social Security number (Section 115.155, RSMo). If you do not have a driver\'s license or a Social Security number, please write "NONE" on the form. A unique identifying number will be assigned by the State. Any electronic media, printouts or mailing labels provided under this section shall not include telephone numbers and Social Security numbers of voters (Section 115.157, RSMo).',
                        signature:
                          'To register in Missouri you must: \nbe a citizen of the United States \nbe a resident of Missouri \nbe at least 17-1/2 years of age (you must be 18 to vote) \nnot be on probation or parole after conviction of a felony, until finally discharged from such probation or parole \nnot be convicted of a felony or misdemeanor connected with the right of suffrage \nnot be adjudged incapacitated by any court of law \nnot be confined under a sentence of imprisonment',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://s1.sos.mo.gov/elections/voterlookup/',
                  'voter-registration-authority-level': ['municipal', 'county'],
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2M1MVqE',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '65101',
                city: 'Jefferson City',
                state: 'MO',
                street: '600 West Main Street',
                'routing-code': '65101',
              },
              'polling-place-url':
                'https://voteroutreach.sos.mo.gov/PRD/VoterOutreach/VOSearch.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2mmiL31',
              'local-reg-authority-lookup-url':
                'https://www.sos.mo.gov/elections/goVoteMissouri/localelectionauthority',
              'local-election-authority-lookup-url':
                'https://www.sos.mo.gov/elections/goVoteMissouri/localelectionauthority',
            },
            {
              id: '57ed552c-a9be-4001-956e-f5a2a61eba5d',
              email: 'sos.elect@nebraska.gov',
              phone: '(402) 471-2555',
              'office-name': 'Nebraska',
              'homepage-url': 'http://www.sos.ne.gov/dyindex.html',
              'ocd-division': [
                'ocd-division/country:us/state:ne',
                'Nebraska',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "If you've voted in Nebraska before, you do not have to show ID to vote.\n\nIf you're a first-time voter who registered to vote by mail, and didn't include a copy of your ID when you registered, you'll need to show ID to vote. Acceptable forms include: any current photo ID; or a current utility bill, bank statement, government check, paycheck, or other government document that shows your name and address.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'ne_absentee' }],
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      url: 'https://www.nebraska.gov/apps-sos-voter-registration/',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Nebraska ID to use Nebraska's online voter registration system. If you don't have a Nebraska-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "You must provide your Nebraska driver's license number. If you do not have a Nebraska driver's license number then you must list the last four digits of your Social Security number.",
                        signature:
                          'To register in Nebraska you must: \nbe a citizen of the United States \nbe a resident of Nebraska \nbe at least 18 years of age or will be 18 years of age on or before the first Tuesday after the first Monday of November \nnot have been convicted of a felony, or if convicted, it has been at least two years since you have completed your sentence for the felony, including any parole term\nnot have been officially found to be mentally incompetent',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://www.votercheck.necvr.ne.gov/VoterView/RegistrantSearch.do',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mmmi1d',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '68508',
                city: 'Lincoln',
                state: 'NE',
                street: '1221 N Street, Suite 103',
                'routing-code': '68508',
              },
              'polling-place-url':
                'https://www.votercheck.necvr.ne.gov/VoterView/PollingPlaceSearch.do',
              'polling-place-url-shortened': 'https://tvote.org/2mZbebU',
              'local-reg-authority-lookup-url':
                'http://www.sos.ne.gov/elec/clerks.html',
              'local-election-authority-lookup-url':
                'http://www.sos.ne.gov/elec/clerks.html',
            },
            {
              id: '57ed552a-402e-4db3-9f8e-7ab5ae6fbae8',
              phone: '(404) 656-2871',
              'office-name': 'Georgia',
              'homepage-url': 'http://sos.ga.gov/index.php/elections',
              'ocd-division': [
                'ocd-division/country:us/state:ga',
                'Georgia',
                {
                  'voting-methods': [
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'ga_absentee' }],
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will need to show photo ID to vote in Georgia.  Acceptable forms include: any valid state or federal government issued photo ID, including a free ID card issued by your county registrar's office or the Georgia Department of Driver Services (DDS); Georgia driver's license, even if expired; valid employee photo ID from any branch, department, agency, or entity of the US Government, Georgia, or any county, municipality, board, authority or other entity of this state; valid US passport ID; valid US military photo ID; student photo ID card issued by a Georgia public college, university, or technical school; or a valid tribal photo ID.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot. If you are a first-time voter, you will need to provide a copy of your ID within three days after the election to your County Board of Elections and Registration. As long as you do so, your provisional ballot will be counted, as long as you are otherwise eligible to vote.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      url: 'https://registertovote.sos.ga.gov/GAOLVR/welcometoga.do#no-back-button',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Georgia ID to use Georgia's online voter registration system. If you don't have a Georgia-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                    {
                      type: 'by-mail',
                      instructions: {
                        race: 'You are requested, but not required, to fill in this box.',
                        idnumber:
                          "Federal law requires you to provide your full GA driver's license number or GA-issued ID number. If you do not have a GA driver's license or GA ID you must provide the last 4 digits of your Social Security number. Providing your full Social Security number is optional. Your Social Security number will be kept confidential and may be used for comparison with other state agency databases for voter registration identification purposes. If you do not possess a GA driver's license or Social Security number, a unique identifier will be provided for you.",
                        signature:
                          'To register in Georgia you must: \nbe a citizen of the United States \nbe a legal resident of Georgia and of the county in which you want to vote \nbe 18 years old within six months after the day of registration, and be 18 years old to vote\nnot be serving a sentence for having been convicted of a felony \nnot have been judicially determined to be mentally incompetent, unless the disability has been removed',
                      },
                      'acceptable-forms': [
                        { name: 'nvrf', fields: { race: 'requested' } },
                      ],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://www.mvp.sos.ga.gov/MVP/mvp.do',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2m2WW5S',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '30334',
                city: 'Atlanta',
                state: 'GA',
                street: '2 MLK Jr. Drive, Suite 802, Floyd West Tower',
                'routing-code': '30334',
              },
              'polling-place-url': 'https://www.mvp.sos.ga.gov/MVP/mvp.do',
              'polling-place-url-shortened': 'https://tvote.org/2m2WW5S',
              'local-reg-authority-lookup-url':
                'https://elections.sos.ga.gov/Elections/countyregistrars.do',
              'local-election-authority-lookup-url':
                'https://elections.sos.ga.gov/Elections/countyelectionoffices.do',
            },
            {
              id: '57ed552e-88e4-4a71-98d1-d7f84cfe553a',
              email: 'RA-BCEL@pa.gov',
              phone: '(717) 787-5280',
              'office-name': 'Pennsylvania',
              'homepage-url':
                'https://www.dos.pa.gov/VotingElections/Pages/default.aspx',
              'ocd-division': [
                'ocd-division/country:us/state:pa',
                'Pennsylvania',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: false,
                      instructions: {
                        'voting-id':
                          "You must provide your driver's license number, the last 4 digits of your Social Security number, or a copy of an acceptable photo ID when applying for an absentee ballot.\n\nYou may provide identifying number to county over the phone, by email or mail.",
                      },
                      'excuse-required': true,
                      'acceptable-forms': [{ name: 'pa_absentee' }],
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "If you've voted at your polling place before, you don't need to show ID to vote.\n\nIf you're a first-time voter, or if you moved within Pennsylvania and are voting for the first time at a new polling place, you must show ID to vote. Acceptable forms include: Pennsylvania driver's license or PennDOT ID card; ID issued by Pennsylvania or the US government; US passport; US military ID; student ID; employee ID; a confirmation issued by the County Voter Registration Office; non-photo ID issued by Pennsylvania or the US government; firearm permit; or a copy of a current utility bill, bank statement, paycheck, or a government check that includes your name and address.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        race: 'You are requested by the Federal Voting Rights Act to fill in this box.',
                        idnumber:
                          'You must supply a driver\'s license number, if you have one. If you do not have a driver\'s license number, you must supply the last four digits of your Social Security number. If you do not have a Social Security number, please write "NONE" in the box.',
                        signature:
                          'To register in Pennsylvania you must: \nbe a citizen of the United States at least one month before the next election \nbe a resident of Pennsylvania and your election district at least 30 days before the election \nbe at least 18 years of age on the day of the next election',
                      },
                      'acceptable-forms': [
                        { name: 'nvrf', fields: { race: 'requested' } },
                      ],
                    },
                    {
                      url: 'https://www.PAVoterServices.pa.gov/Pages/VoterRegistrationApplication.aspx',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Pennsylvania ID to use Pennsylvania's online voter registration system. If you don't have a Pennsylvania ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://www.pavoterservices.state.pa.us/Pages/voterregistrationstatus.aspx',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2n6HmqX',
                },
              ],
              'official-title': 'Department of State',
              'physical-address': {
                zip: '17120',
                city: 'Harrisburg',
                state: 'PA',
                street: '210 North Office Building, 401 North Street',
                'routing-code': '17120',
              },
              'polling-place-url':
                'https://www.pavoterservices.pa.gov/Pages/PollingPlaceInfo.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2mju0aU',
              'local-reg-authority-lookup-url':
                'https://www.votespa.com/Resources/Pages/Contact-Your-Election-Officials.aspx',
              'local-election-authority-lookup-url':
                'https://www.votespa.com/Resources/Pages/Contact-Your-Election-Officials.aspx',
            },
            {
              id: '57ed552f-ae18-49b7-aed5-9d07ca309355',
              email: 'elections@wyo.gov',
              phone: '307-777-5860',
              'office-name': 'Wyoming',
              'homepage-url': 'https://soswy.state.wy.us/elections/',
              'ocd-division': [
                'ocd-division/country:us/state:wy',
                'Wyoming',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "If you've voted in Wyoming before,  you do not need to show ID to vote.\n\nIf you're a first-time voter who registered by mail, you will need to show ID to vote. Acceptable forms include: Wyoming driver's license or Wyoming-issued ID card; or a current utility bill, bank statement, government check, paycheck, or government document that shows your name and address.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot. Your ballot will be counted if you are able to provide ID to your election office before the close of business one day after the election.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      instructions: {
                        'voting-id':
                          'If you registered to vote by mail and are voting by absentee ballot in your first federal election, you must enclose a copy of your photo ID or document bearing your name and residence address in the envelope with your voted ballot.',
                      },
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'wy_absentee' }],
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "Present a valid Wyoming driver's license if you have one, and if not provide the last four digits of your Social Security number. (If you have neither, please indicate this on the form). You will also need to show a valid driver's license; ID issued by a local, state or federal agency; U.S. passport; school ID; or military ID to the notary or person authorized to administer oaths. You will need to mail a photocopy of this ID with your voter registration form.",
                        signature:
                          'To register in Wyoming you must sign the voter registration oath and have the notary or registered agent sign the form: "I do solemnly swear (or affirm) that I am a citizen of the United States; that I am a bona fide resident of the state of Wyoming and this county; that if registered in another county or state, I hereby request that my registration be withdrawn; that I will be at least eighteen (18) years of age on or before the next election; that I am not currently adjudicated a mentally incompetent person; that I have not been convicted of a felony, or if I have been convicted of a felony, I have had my civil or voting rights restored by a competent authority; and that the voter registration information contained herein is true and accurate to my best knowledge and belief."',
                        'citizenship-docs':
                          "Wyoming requires that you notarize your voter registration form if you plan to submit it by mail. Do not sign this form until you are in the presence of your county clerk or election official. If you're going to be at home on Election Day, you should plan to register and vote in person.",
                      },
                      'acceptable-forms': [{ name: 'wy-reg' }],
                    },
                    { type: 'election-day' },
                  ],
                  'voter-registration-status-url':
                    'http://soswy.state.wy.us/Elections/Docs/WYCountyClerks.pdf',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2m302H8',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '82002',
                city: 'Cheyenne',
                state: 'WY',
                street: '2020 Carey Avenue, Suite 600',
                'routing-code': '82002',
              },
              'polling-place-url':
                'https://soswy.state.wy.us/Elections/PollPlace/Default.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2nfbJL3',
              'local-reg-authority-lookup-url':
                'https://soswy.state.wy.us/Elections/Docs/WYCountyClerks.pdf',
              'local-election-authority-lookup-url':
                'https://soswy.state.wy.us/Elections/Docs/WYCountyClerks.pdf',
            },
            {
              id: '57ed552e-007d-4b32-ac1a-04342bf1c9c6',
              phone: '(615) 741-7956',
              'office-name': 'Tennessee',
              'homepage-url': 'https://sos.tn.gov/elections',
              'ocd-division': [
                'ocd-division/country:us/state:tn',
                'Tennessee',
                {
                  'voting-methods': [
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will need to show photo ID to vote in Tennessee. Acceptable forms include (can be expired): Tennessee driver's license; US passport; photo ID issued by the Tennessee Department of Safety and Homeland Security; photo ID issued by the federal or Tennessee state government; US military photo ID; or Tennessee handgun carry permit with your photo. \n\nIf you're a first-time voter who registered by mail, you will also need to show proof of residence to vote. Acceptable forms include: a current photo ID (unexpired); or a copy of a current utility bill, bank statement, government check, paycheck or other government document that shows your name and address.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot. You will then have two (2) business days after Election Day to return to the election commission office to show a valid photo ID. Upon returning to the election commission office, the voter will sign an affidavit and a copy of the voter's photo ID will be made to be reviewed by the counting board.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      instructions: {
                        'voting-id':
                          'If you register by mail, you must vote in person the first time you vote after registering.',
                      },
                      'excuse-required': true,
                      'acceptable-forms': [{ name: 'tn_absentee' }],
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        race: 'Optional.',
                        idnumber:
                          'Your full Social Security number is required. Social Security number, if any, is required for purposes of identification and to avoid duplicate registration (TCA 2.2.116).',
                        signature:
                          'To register in Tennessee you must: \nbe a citizen of the United States \nbe a resident of Tennessee \nbe at least 18 years old on or before the next election \nnot have been convicted of a felony, or if convicted, have had your voting rights restored \nnot be adjudicated incompetent by a court of competent jurisdiction (or have been restored to legal capacity)',
                        'citizenship-docs':
                          'If you register by mail, you must vote in person the first time you vote after registering.',
                      },
                      'acceptable-forms': [
                        { name: 'nvrf', fields: { race: 'optional' } },
                      ],
                    },
                    {
                      url: 'https://ovr.govote.tn.gov/',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: You must have a Tennessee driver's license or Tennessee Department of Safety and Homeland Security ID in order to submit this application online. If you do not have a Tennessee ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://tnmap.tn.gov/voterlookup/',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2lZlAnb',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '37243',
                city: 'Nashville',
                state: 'TN',
                street: '312 Rosa L. Parks Avenue, 7th Floor, Snodgrass Tower',
                'routing-code': '37243',
              },
              'polling-place-url': 'https://tnmap.tn.gov/voterlookup/',
              'polling-place-url-shortened': 'https://tvote.org/2lZlAnb',
              'local-reg-authority-lookup-url':
                'https://tnsos.org/elections/election_commissions.php',
              'local-election-authority-lookup-url':
                'https://tnsos.org/elections/election_commissions.php',
            },
            {
              id: '57ed552d-8488-4e43-83ab-f5bfc703bb0e',
              email: 'soselect@nd.gov',
              phone: '701-328-4146',
              'office-name': 'North Dakota',
              'homepage-url': 'https://vip.sos.nd.gov/PortalList.aspx',
              'ocd-division': [
                'ocd-division/country:us/state:nd',
                'North Dakota',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: false,
                      instructions: {
                        'voting-id':
                          "Voting absentee or by mail requires a valid driver's license or state ID card; a valid government-issued tribal ID card; or a long-term care identification certificate (provided by ND facility); passport or military ID (only for North Dakota residents living outside the United States who do not possess one of the other forms of identification); or a voter's affidavit. Identification must include the voter's name, current residential street address, and date of birth.\n\nVoters without ID: an applicant without a valid form of identification may use an attester. The attester must provide his or her name, North Dakota driver's license, non-driver's, or tribal identification number, and sign the absentee/mail ballot application form to attest to the applicant's North Dakota residency and voting eligibility.",
                      },
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'nd_absentee' }],
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will be asked to show ID to vote in North Dakota. Your identification must include your name, current residential street address, and date of birth. Acceptable forms include: a current driver's license or non-driver's ID card; tribal-government-issued ID card; or a long-term care certificate (provided by ND facility).",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'not-applicable',
                      instructions: {
                        instructions:
                          "North Dakota does not register voters. If you are an eligible resident of North Dakota, you're already set to vote!",
                      },
                    },
                  ],
                  'voter-registration-authority-level': 'county',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '58505',
                city: 'Bismarck',
                state: 'ND',
                street: '600 E Boulevard Avenue Dept 108',
                'routing-code': '58505',
              },
              'polling-place-url':
                'https://vip.sos.nd.gov/WhereToVote.aspx?tab=AddressandVotingTimes',
              'polling-place-url-shortened': 'https://tvote.org/2lElrdO',
              'local-reg-authority-lookup-url':
                'https://vip.sos.nd.gov/CountyAuditors.aspx',
              'local-election-authority-lookup-url':
                'https://vip.sos.nd.gov/CountyAuditors.aspx',
            },
            {
              id: '57ed552b-e540-4327-8346-687ddd1fee96',
              phone: '208-334-2852',
              'office-name': 'Idaho',
              'homepage-url': 'https://idahovotes.gov/',
              'ocd-division': [
                'ocd-division/country:us/state:id',
                'Idaho',
                {
                  'voting-methods': [
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'id_absentee' }],
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will be asked to show photo ID to vote in Idaho. Acceptable forms include: Idaho driver's license or Idaho photo ID card; US passport or federal photo ID card; tribal photo ID; a current student photo ID issued by an Idaho high school, college, or technical school; or a license to carry a concealed weapon issued by a county sheriff in Idaho.\n\nVoters without ID: If you are unable to provide ID, you will be given the option of signing the Personal Identification Affidavit in order to cast a ballot.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "Enter your driver's license number. If you have no driver's license, enter the last 4 digits of your Social Security number.",
                        signature:
                          'To register in Idaho you must: \nbe a citizen of the United States \nhave resided in Idaho and in the county for 30 days prior to the day of election \nbe at least 18 years old \nnot have been convicted of a felony, and without having been restored to the rights of citizenship, or confined in prison on conviction of a criminal offense',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    {
                      url: 'https://apps.idahovotes.gov/OnlineVoterRegistration',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need an Idaho ID to use Idaho's online voter registration system. If you don't have an Idaho-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                    { type: 'election-day' },
                  ],
                  'voter-registration-status-url':
                    'https://apps.idahovotes.gov/YourPollingPlace/AmIRegistered.aspx',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2KAowmt',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '83702',
                city: 'Boise',
                state: 'ID',
                street: 'East Wing, Second Floor, 700 West Jefferson E205',
                'routing-code': '83702',
              },
              'polling-place-url':
                'https://apps.idahovotes.gov/YourPollingPlace/WhereDoIVote.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2LlFwlV',
              'local-reg-authority-lookup-url':
                'https://idahovotes.gov/county-clerks/',
              'local-election-authority-lookup-url':
                'https://idahovotes.gov/county-clerks/',
            },
            {
              id: '57ed552b-2362-41c8-90cf-3661e9997e24',
              email: 'elections@hawaii.gov',
              phone: '808-453-8683',
              'office-name': 'Hawaii',
              'homepage-url': 'https://elections.hawaii.gov/',
              'ocd-division': [
                'ocd-division/country:us/state:hi',
                'Hawaii',
                {
                  'voting-methods': [
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "If you've voted in Hawaii before, you don't need to provide ID to vote.\n\nIf you're a first-time voter who registered by mail, and didn't provide a copy of your ID when you registered, you will need to show ID to vote. Acceptable forms include: current driver's license or state ID card; or a copy of a current utility bill, bank statement, paycheck, or other government issued document that shows your name and address.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot. You must provide the clerk's office acceptable identification two days after the election for the ballot to be counted.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'hi_absentee' }],
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        race: 'Race or ethnic group information is not required for voter registration.',
                        idnumber:
                          'When you register to vote, you must provide your Hawaii driver’s license or State identification number, if you have one. If you do not have a driver’s license or ID number, you must provide the last four digits of your Social Security number (SSN). If you do not have any of this information, the Clerk’s Office will issue you a unique identification number, which will serve to identify you for voter registration purposes.',
                        signature:
                          'To register in Hawaii you must: \nbe a citizen of the United States \nbe a resident of the State of Hawaii \nbe at least 16 years old (you must be 18 years old by election day in order to vote) \nnot be incarcerated for a felony conviction \nnot be adjudicated by a court as "non compos mentis"',
                      },
                      'acceptable-forms': [
                        { name: 'nvrf', fields: { race: 'optional' } },
                      ],
                    },
                    {
                      url: 'https://olvr.hawaii.gov/register.aspx',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Hawaii ID and a Social Security number to use Hawaii's online voter registration system. If you don't have a Hawaii-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                    { type: 'election-day' },
                  ],
                  'voter-registration-status-url':
                    'https://olvr.hawaii.gov/(S(qowv0cpggasxu4oziahjrvvk))/Default.aspx',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2m2UZGN',
                },
              ],
              'official-title': 'Office of Elections',
              'physical-address': {
                zip: '96782',
                city: 'Pearl City',
                state: 'HI',
                street: '802 Lehua Avenue',
                'routing-code': '96782',
              },
              'polling-place-url':
                'https://olvr.hawaii.gov/altpollingplacesearch.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2mGtuGr',
              'local-reg-authority-lookup-url':
                'https://elections.hawaii.gov/resources/county-election-divisions/',
              'local-election-authority-lookup-url':
                'https://elections.hawaii.gov/resources/county-election-divisions/',
            },
            {
              id: '57ed552f-8ef9-4542-88da-2825ea172d9f',
              email: 'elections@wi.gov',
              phone: '(608) 266-8005',
              types: ['registration'],
              'office-name': 'Wisconsin',
              'homepage-url': 'https://elections.wi.gov/elections-voting',
              'ocd-division': [
                'ocd-division/country:us/state:wi',
                'Wisconsin',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: false,
                      instructions: {
                        'voting-id':
                          "Active Military and Permanent Overseas voters are not required to provide a Photo ID when they vote by absentee ballot. For all other absentee voters, you will need to provide a copy of your acceptable photo ID with your request.  If you have not previously provided a copy of photo ID, photo ID must accompany your first application by mail. \n\nThese photo IDs are acceptable and can be unexpired or expired after the date of the most recent general election, currently, the November 6, 2018 election: A Wisconsin DOT-issued driver license, even if driving privileges are revoked or suspended; A Wisconsin DOT-issued identification card; Military ID card issued by a U.S. uniformed service; A U.S. passport.\n\nThese photo IDs are also acceptable for voting purposes, but must be unexpired: A veteran's photo identification card issued by the Veterans Health Administration of the federal Department of Veterans Affairs; A certificate of naturalization that was issued not earlier than two years before the date of an election at which it is presented; A driving receipt issued by Wisconsin DOT (valid for 45 days); An identification card receipt issued by Wisconsin DOT (valid for 45 days); An identification card issued by a federally recognized Indian tribe in Wisconsin; A photo identification card issued by a Wisconsin accredited university or college that contains date of issuance, expiration date no later than two years after issuance, and signature of student (must be accompanied by a separate document that proves enrollment).",
                      },
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'wi_absentee' }],
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will need to show a photo ID to vote in Wisconsin. Acceptable forms include: Wisconsin driver's license or state ID card; military ID; tribal ID card issued by a federally recognized Indian tribe in Wisconsin; US passport; photo ID card issued by a Wisconsin accredited university or college that contains date of issuance, expiration date no later than two years after issuance, and signature of student (must be accompanied by a separate document that proves enrollment); veteran's photo ID card issued by the Veterans Health Administration of the federal Department of Veterans Affairs (unexpired); certificate of naturalization that was issued not earlier than two years before the date of an election at which it is presented; driving receipt issued by Wisconsin DOT (valid for 45 days); ID card receipt issued by Wisconsin DOT (valid for 45 days); temporary identification card receipt issued by Wisconsin DOT through the Identification Petition Process (IDPP) (valid for 180 days); or a citation or notice of intent to revoke or suspend a Wisconsin DOT-issued driver license that is dated within 60 days of the date of the election.\n\nIf you didn't provide Proof of Residence documentation when you registered, you will need to do so to vote. All Proof of Residence documents must show your name and current residential address. Acceptable forms include: Wisconsin driver's license or state ID card; any other ID card or license issued by a Wisconsin governmental agency or unit; employee ID card with a photograph, but not including a business card; real estate tax bill or receipt for the current year or the year preceding the date of the election; residential lease; a university, college, or technical college identification card (must include photo) ONLY if you provide a fee receipt dated within the last 9 months or your university, college, or technical college provides a certified housing list to the municipal clerk; a letter on public or private social service agency letterhead identifying a homeless voter and describing the individual’s residence for voting purposes; an intake document from a residential care facility such as a nursing home or assisted living facility; utility bill dated within 90 days; or a bank statement, credit card statement, paycheck, government check or other government-issued document.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot. Your provisional ballot will not count unless you provide acceptable proof of identification to your municipal clerk in person by 4:00 p.m. the Friday after the election.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'municipal',
                  'voter-registration-methods': [
                    {
                      url: 'https://myvote.wi.gov/en-us/RegisterToVote',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Wisconsin ID to use Wisconsin's online voter registration system. The address where you're registering needs to match the address the DMV has on file for you. If you don't have a Wisconsin ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                    {
                      type: 'by-mail',
                      instructions: {
                        race: 'Not required.',
                        idnumber:
                          'Provide your unexpired Wisconsin driver license or DOT-issued ID card number. If you do not have a current and valid DOT-issued driver license or ID card, provide the last four digits of your social security number. \n\nYou must also provide Proof of Residence documentation when registering. All Proof of Residence documents must show your name and current residential address. Acceptable forms include: a copy of your current and valid State of WI Driver’s License or State ID card; any other official identification card or license issued by a WI governmental body or unit; any identification card issued by an employer with a photo of the card holder, but not including a business card; a real estate tax bill or receipt for the current year or the year preceding the date of the election; a university, college or technical college identification card (must include photo) ONLY if the voter provides a fee receipt dated within the last 9 months or the institution provides a certified housing list to the municipal clerk; a gas, electric or telephone service statement (utility bill) for the period commencing no earlier than 90 days before Election Day; a bank or credit card statement; a paycheck or paystub;  a check or other document issued by a unit of government; a letter on public or private social service agency letterhead identifying a homeless voter and describing the individual’s residence for voting purposes; an intake document from a residential care facility such as a nursing home or assisted living facility.',
                        signature:
                          'To register in Wisconsin you must: \nbe a citizen of the United States \nbe a resident of Wisconsin and have resided at the registration address for at least 10 days \nbe 18 years old \nnot have been convicted of treason, felony or bribery, or if you have, your civil rights have been restored after completion of your sentence or a pardon \nnot have been found by a court to be incapable of understanding the objective of the electoral process \nnot make or benefit from a bet or wage depending on the result of an election \nnot have voted at any other location, if registering on election day',
                      },
                      'acceptable-forms': [
                        { name: 'nvrf', fields: { race: 'optional' } },
                      ],
                    },
                    { type: 'election-day' },
                  ],
                  'voter-registration-status-url':
                    'https://myvote.wi.gov/en-us/MyVoterInfo',
                  'voter-registration-authority-level': 'state',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mZdb8x',
                },
              ],
              'official-title': 'Elections Commission',
              'mailing-address': {
                zip: '53707-7984',
                city: 'Madison',
                state: 'WI',
                street: 'PO Box 7984',
                'routing-code': '537077984',
              },
              'physical-address': {
                zip: '53707',
                city: 'Madison',
                state: 'WI',
                street: '212 East Washington Avenue, Third Floor',
                'routing-code': '53707',
              },
              'polling-place-url':
                'https://myvote.wi.gov/en-us/FindMyPollingPlace',
              'polling-place-url-shortened': 'https://tvote.org/2m2O3JQ',
              'local-reg-authority-lookup-url':
                'https://myvote.wi.gov/en-US/MyMunicipalClerk',
              'local-election-authority-lookup-url':
                'https://myvote.wi.gov/en-US/MyMunicipalClerk',
            },
            {
              id: '57ed552a-2b7d-49b7-92fb-9ef4e522a331',
              email: 'elections@sos.state.co.us',
              phone: '303-894-2200',
              'office-name': 'Colorado',
              'homepage-url': 'https://www.sos.state.co.us/pubs/elections/',
              'ocd-division': [
                'ocd-division/country:us/state:co',
                'Colorado',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: true,
                      'excuse-required': false,
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: false,
                      instructions: {
                        'voting-id':
                          "If you choose to vote in person in Colorado, you will need to show ID. If your form of identification shows your address, that address must be in the state of Colorado.\n\nAcceptable forms include: Colorado driver's license; valid photo ID card issued by the Department of Revenue; US passport; employee ID with photo issued by any entity of the US government or Colorado; pilot's license issued by the FAA or other authorized agency of the US; US military ID with photo; ID card issued by a federally recognized tribal government; Medicare or Medicaid card; certified copy of your US birth certificate; certificate of Degree of Indian or Alaskan Native Blood; certified documentation of naturalization; student ID with photo issued by a Colorado institute of higher education; veteran's ID with photo issued by the VA; or a current utility bill, bank statement, government check, paycheck, or other government document showing name and address (within last 60 days).\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot, or you may request a mail ballot to take home, sign, and return to your county clerk. Your signature is used to verify your identity on a mail ballot",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      url: 'https://www.sos.state.co.us/voter/pages/pub/olvr/verifyNewVoter.xhtml',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Colorado ID to use Colorado's online voter registration system. If you don't have a Colorado-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': true,
                    },
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "Your completed voter registration form must contain your Colorado-issued driver's license number or identification number. If you do not have a driver's license or CO-issued identification, you must include the last four digits of your Social Security number. If you do not have a driver's license or a CO-issued identification or a Social Security number, please write \"NONE\" on the form. A unique identifying number will be assigned by the State.",
                        signature:
                          'To register in Colorado you must: \nbe a citizen of the United States \nbe a resident of Colorado for at least 22 days immediately before the Election in which you intend to vote \nbe at least 16 years old, but you must be at least 17 and turning 18 on or before the date of the next general election to be eligible to vote in a primary election, and at least 18 to be eligible to vote in any other election\nnot be serving a sentence of detention or confinement for a felony conviction',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    { type: 'election-day' },
                  ],
                  'voter-registration-status-url':
                    'https://www.sos.state.co.us/voter-classic/pages/pub/olvr/findVoterReg.xhtml',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mmgSDx',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '80290',
                city: 'Denver',
                state: 'CO',
                street: '1700 Broadway, Suite 200',
                'routing-code': '80290',
              },
              'polling-place-url':
                'https://www.sos.state.co.us/voter/pages/pub/olvr/findVoterReg.xhtml',
              'polling-place-url-shortened': 'https://tvote.org/2mmgSDx',
              'local-reg-authority-lookup-url':
                'https://www.sos.state.co.us/pubs/elections/Resources/files/CountyClerkRosterWebsite.pdf',
              'local-election-authority-lookup-url':
                'https://www.sos.state.co.us/pubs/elections/Resources/files/CountyClerkRosterWebsite.pdf',
            },
            {
              id: '57ed552c-9ac9-4f62-9349-76be74ae00dc',
              email: 'elections.sboe@ncsbe.gov',
              phone: '(919) 814-0700',
              'office-name': 'North Carolina',
              'homepage-url': 'https://www.ncsbe.gov/index.html',
              'ocd-division': [
                'ocd-division/country:us/state:nc',
                'North Carolina',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: false,
                      instructions: {
                        'voting-id':
                          "If the voter's identification number (NC driver's license, NC DMV-issued identification number, or last four digits of Social Security number) is not provided, then a copy of one of the following must be provided along with this request: a current and valid photo identification, or a current utility bill, bank statement, government check, paycheck, or other government document that shows your name and address.",
                      },
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'nc_absentee' }],
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "If you've voted in North Carolina before, you don't need to show ID to vote.\n\nIf you're a first-time voter who registered by mail, and didn't provide your driver's license number or the last 4 digits of your Social Security number on your registration form, you will need to show ID to vote. Acceptable forms include: a driver's license or state ID; US Passport; employee ID; student ID; military ID; or a copy of a utility bill, bank statement or paycheck.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        race: 'You are required by the Federal Voting Rights Act to fill in this box. However, your application will not be rejected if you fail to do so.',
                        idnumber:
                          "Provide your North Carolina driver's license number, or North Carolina Department of Motor Vehicles ID number. If you do not have a driver's license, then list the last four digits of your Social Security number.",
                        signature:
                          'To register in North Carolina you must: \nbe a citizen of the United States \nbe a resident of North Carolina and the county in which you live for at least 30 days prior to the election \nbe 18 years of age by the day of the next general election \nhave your rights of citizenship restored if you have been convicted of a felony \nnot be registered or vote in any other county or state',
                      },
                      'acceptable-forms': [
                        { name: 'nvrf', fields: { race: 'required' } },
                      ],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://vt.ncsbe.gov/RegLkup/',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mGnJsq',
                },
              ],
              'official-title': 'State Board of Elections',
              'physical-address': {
                zip: '27603',
                city: 'Raleigh',
                state: 'NC',
                street: 'Third floor, 430 N. Salisbury St.',
                'routing-code': '27603',
              },
              'polling-place-url': 'https://vt.ncsbe.gov/PPLkup/',
              'polling-place-url-shortened': 'https://tvote.org/2lZ7jqK',
              'local-reg-authority-lookup-url': 'https://vt.ncsbe.gov/BOEInfo/',
              'local-election-authority-lookup-url':
                'https://vt.ncsbe.gov/BOEInfo/',
            },
            {
              id: '57ed552b-7d7f-41e1-8eb2-56bece6a77f7',
              phone: '217-782-4141',
              'office-name': 'Illinois',
              'homepage-url': 'https://www.elections.il.gov/',
              'ocd-division': [
                'ocd-division/country:us/state:il',
                'Illinois',
                {
                  'voting-methods': [
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "If you've voted in Illinois before, you don't need to provide ID to vote.\n\nIf you're a first-time voter who registered by mail, and didn't provide your driver's license number, state ID number, last 4 digits of your Social Security number, or a copy of a current ID or government document that shows your name and address when you registered, you'll need to provide one of these when you vote. You can use (i) a copy of a current and valid photo identification, or (ii) a copy of a current utility bill, bank statement, government check, paycheck, or other government document that shows your name and address.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot. After voting provisionally, you will be told how to submit additional proof of registration to the election authority. The additional information must be received by the election authority no later than the close of business on the Tuesday following the election.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'il_absentee' }],
                    },
                  ],
                  'election-authority-level': ['municipal', 'county'],
                  'voter-registration-methods': [
                    {
                      url: 'https://ova.elections.il.gov/Step0.aspx',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need an Illinois ID and a Social Security number to use Illinois's online voter registration system. If you don't have an Illinois-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                    { type: 'election-day' },
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          'Your driver\'s license number or Secretary of State ID card is required to register to vote. If you do not have a driver\'s license, at least the last four digits of your Social Security number are required. If you have neither, please write "NONE" on the form. A unique identifier will be assigned to you by the State.\n\nFor people who do not have either of those items, and have not registered in Illinois before, a mail in registration form should be accompanied by a copy of other identifying information: you must send, with this application, either (i) a copy of a current and valid photo identification, or (ii) a copy of a current utility bill, bank statement, government check, paycheck, or other government document that shows the name and address of the voter. If you do not provide the information required above, then you will be required to provide election officials with either (i) or (ii) described above the first time you vote at a voting place.',
                        signature:
                          'To register in Illinois you must: \nbe a citizen of the United States \nbe a resident of Illinois and of your election precinct at least 30 days before the next election \nbe at least 18 years old on or before the next election \ncannot be serving a sentence of confinement in any penal institution as a result of conviction of any crime \nnot claim the right to vote anywhere else',
                        'citizenship-docs':
                          'A signature is required. If signature is missing from registration form, you will be notified that your registration is incomplete.',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://ova.elections.il.gov/RegistrationLookup.aspx',
                  'voter-registration-authority-level': ['municipal', 'county'],
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2m2R90p',
                },
              ],
              'official-title': 'State Board of Elections',
              'physical-address': {
                zip: '62704',
                city: 'Springfield',
                state: 'IL',
                street: '2329 S. MacArthur Blvd',
                'routing-code': '62704',
              },
              'polling-place-url':
                'https://ova.elections.il.gov/PollingPlaceLookup.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2OjsO3X',
              'local-reg-authority-lookup-url':
                'https://www.elections.il.gov/ElectionOperations/ElectionAuthorities.aspx?MID=cQHxtxVEmuo%3d',
              'local-election-authority-lookup-url':
                'https://www.elections.il.gov/ElectionOperations/ElectionAuthorities.aspx?MID=cQHxtxVEmuo%3d',
            },
            {
              id: '57ed552b-3ca9-4e78-b8f8-96aff7ada2fa',
              phone: '207-624-7736',
              'office-name': 'Maine',
              'homepage-url': 'https://www.maine.gov/sos/cec/elec/index.html',
              'ocd-division': [
                'ocd-division/country:us/state:me',
                'Maine',
                {
                  'voting-methods': [
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'me_absentee' }],
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "If you've voted in Maine before, you don't need to provide ID to vote.\n\nIf you're a first-time voter that registered by mail, and didn't provide a copy of your Maine driver's license, Maine state ID card, or a current utility bill, bank statement, government check, paycheck, or government document that shows your name and address when you registered, you may need to show one of these documents to vote.\n\nVoters without ID: If you don't have ID or proof of residence, you can cast a challenged ballot. You may be asked to provide ID after the election for your ballot to count.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'municipal',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "You must list your valid Maine driver's license number. If you don't have a valid Maine driver's license, then you must provide the last four digits of your Social Security number. Voters who don't have either of these forms of ID must write \"NONE\" in this space.",
                        signature:
                          'To register in Maine you must: \nbe a citizen of the United States \nbe a resident of Maine and the municipality in which you want to vote \nbe at least 17 years old (you must be 18 years old to vote)',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    { type: 'election-day' },
                  ],
                  'voter-registration-status-url':
                    'https://www1.maine.gov/portal/government/edemocracy/voter_lookup.php',
                  'voter-registration-authority-level': 'municipal',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2Mb9MzA',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '04333-0101',
                city: 'Augusta',
                state: 'ME',
                street: 'Burton Cross Building, 111 Sewall St., 4th Floor',
                'routing-code': '043330101',
              },
              'polling-place-url':
                'https://www1.maine.gov/portal/government/edemocracy/voter_lookup.php',
              'polling-place-url-shortened': 'https://tvote.org/2mZa9RH',
              'local-reg-authority-lookup-url':
                'https://www.maine.gov/sos/cec/elec/munic.html',
              'local-election-authority-lookup-url':
                'https://www.maine.gov/sos/cec/elec/munic.html',
            },
            {
              id: '57ed552d-bed4-4c0c-8591-670b99fcba7c',
              phone: '(614) 466-2655',
              'office-name': 'Ohio',
              'homepage-url': 'https://www.sos.state.oh.us/elections/',
              'ocd-division': [
                'ocd-division/country:us/state:oh',
                'Ohio',
                {
                  'voting-methods': [
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'oh_absentee' }],
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will need to show ID to vote in Ohio. Acceptable forms include: an unexpired Ohio driver's license or state ID card; a military ID; a photo ID issued by the US government or the State of Ohio, that contains your name and current address and that has an expiration date that has not passed; or a current utility bill (within the last 12 months), bank statement, government check, paycheck, or other government document (other than a notice of voter registration mailed by a board of elections) that shows your name and current address.\n\nVoters without ID: If you do not have any of the above forms of identification you may provide either your Ohio driver’s license or state identification number (which begins with two letters followed by six numbers) or the last four digits of your Social Security number and cast a provisional ballot. Once the information is reviewed and verified by the board of elections, your ballot will be counted.\n\nIf you do not provide one of the above documents or your driver’s license/state identification number or the last four digits of your Social Security number at the precinct, you will still be able to vote using a provisional ballot. However, in order for that ballot to be counted, you must return to the board of elections no later than seven days following Election Day to provide a qualifying form of identification.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      url: 'https://olvr.sos.state.oh.us/ovru/Modify.aspx',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need an Ohio ID and a Social Security number to use Ohio's online voter registration system. If you don't have an Ohio-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "Your Social Security number is requested. Providing this number is voluntary. This information allows the Board of Elections to verify your registration if necessary (O.R.C. 3503.14). [Federal law requires that you provide your driver's license number to register to vote. If you do not have a driver's license then you will have to provide at least the last four digits of your Social Security number. If you don't have either number you will have to write \"NONE\" on the form and the State will assign you a number.]",
                        signature:
                          'To register in Ohio you must: \nbe a citizen of the United States \nbe a resident of Ohio \nbe 18 years old on or before election day. If you will be 18 on or before the day of the general election, you may vote in the primary election for candidates only. \nnot be incarcerated (in jail or in prison) for a felony conviction\nnot be found incompetent by a court for purposes of voting',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://voterlookup.ohiosos.gov/voterlookup.aspx',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mlN3Wu',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '43215',
                city: 'Columbus',
                state: 'OH',
                street: '180 East Broad Street, 16th Floor',
                'routing-code': '43215',
              },
              'polling-place-url':
                'https://voterlookup.ohiosos.gov/voterlookup.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2n6G1QS',
              'local-reg-authority-lookup-url':
                'https://www.sos.state.oh.us/sos/elections/electionsofficials/boeDirectory.aspx',
              'local-election-authority-lookup-url':
                'https://www.sos.state.oh.us/elections/elections-officials/county-boards-of-elections-directory/',
            },
            {
              id: '57ed552c-8d89-4721-a6f1-21074cb6d426',
              email: 'njelections@sos.nj.gov',
              phone: '(609) 292-3760',
              'office-name': 'New Jersey',
              'homepage-url': 'https://nj.gov/state/elections/index.html',
              'ocd-division': [
                'ocd-division/country:us/state:nj',
                'New Jersey',
                {
                  'voting-methods': [
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "If you've voted in New Jersey before, you don't need to provide ID to vote.\n\nIf you're voting for the first-time in your county, registered to vote by mail, and didn't provide an ID number or copy of ID when you registered, you must show ID to vote. Acceptable forms include: NJ photo or non-photo driver's license; military or other government ID; student ID; employee ID; store membership card; US passport; or bank statement, car registration, government check or document, rent receipt, sample ballot, utility bill, or any other official document.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'nj_absentee' }],
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          'The last four digits of your Social Security number OR your New Jersey driver\'s license number is required for voter registration. If you do not possess either of these identifications, please write "NONE" on the form. The State will assign a number that will serve to identify you for voter registration purposes.',
                        signature:
                          'To register in New Jersey you must: \nbe a citizen of the United States\nbe at least 17 years old (you must be 18 to vote)\nbe a resident of the State and county 30 days before the election\nnot be serving a sentence or on parole or probation as the result of a conviction of any indictable offense under the laws of this or another state or of the United States',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://voter.njsvrs.com/PublicAccess/servlet/com.saber.publicaccess.control.PublicAccessNavigationServlet?USERPROCESS=PublicSearch',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mC4fF3',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '08608',
                city: 'Trenton',
                state: 'NJ',
                street: '33 W State Street',
                'routing-code': '08608',
              },
              'polling-place-url':
                'https://voter.njsvrs.com/elections/polling-lookup.html',
              'polling-place-url-shortened': 'https://tvote.org/2NDB9PR',
              'local-reg-authority-lookup-url':
                'https://www.state.nj.us/state/elections/voting-information-local-officials.html',
              'local-election-authority-lookup-url':
                'https://www.state.nj.us/state/elections/voting-information-local-officials.html',
            },
            {
              id: '57ed552e-6ed8-4d17-9552-721b77973752',
              email: 'elections@sos.texas.gov',
              phone: '(512) 463-5650',
              'office-name': 'Texas',
              'homepage-url': 'https://www.sos.state.tx.us/elections/',
              'ocd-division': [
                'ocd-division/country:us/state:tx',
                'Texas',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': true,
                      'acceptable-forms': [{ name: 'tx_absentee' }],
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will be asked to show photo ID to vote in Texas. Acceptable forms include (must be current or expired less than 4 years): Texas driver's license issued by the Texas Department of Public Safety (DPS); Texas election ID certificate; Texas personal ID card; Texas handgun license; US military ID with photo; US citizenship certificate with photograph (doesn't need to be current); or a US passport.\n\nVoters without ID: If you don't have ID and cannot obtain one due to a reasonable impediment, you'll need to sign a sworn statement that there is a reason why you don't have any of the accepted IDs, and present one of the following: certified birth certificate (original); valid voter registration certificate; or a current utility bill, government check, bank statement or paycheck, or government document with your name and an address (original required if it contains a photograph). If you meet these requirements and are eligible to vote, you may vote in the election.\n\nIf you don't have ID and do not have a reasonable impediment to obtaining one or did not bring ID to the polling place, you may cast a provisional ballot. In order to have the provisional ballot counted, you will be required to visit the voter registrar's office within six (6) calendar days of the date of the election to either present one of the forms of photo ID or submit a temporary affidavit, or, if applicable, qualify for the disability exemption, in the presence of the county voter registrar while attesting to the fact that you do not have any of the required photo IDs.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          'You must provide your Texas driver\'s license number to register to vote. If you do not have a driver\'s license then you will have to provide at least the last four digits of your Social Security number. If you have neither, please write "NONE" on the form. A unique identifying number will instead be assigned to you by your State.',
                        signature:
                          'To register in Texas you must: \nbe a citizen of the United States\nbe a resident of the county in which the application for registration is made \nbe at least 17 years and 10 months old (you must be 18 to vote) \nnot be finally convicted of a felony, or if a convicted felon, you must have fully discharged your punishment, including any incarceration, parole, supervision, period of probation or be pardoned\nhave not been declared mentally incompetent by final judgment of a court of law',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://teamrv-mvp.sos.texas.gov/MVP/mvp.do',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mjxn1m',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '78701',
                city: 'Austin',
                state: 'TX',
                street: 'James E. Rudder Bldg., 1019 Brazos St.',
                'routing-code': '78701',
              },
              'polling-place-url':
                'https://teamrv-mvp.sos.texas.gov/MVP/mvp.do',
              'polling-place-url-shortened': 'https://tvote.org/2mjxn1m',
              'local-reg-authority-lookup-url':
                'https://www.sos.state.tx.us/elections/voter/votregduties.shtml',
              'local-election-authority-lookup-url':
                'https://www.sos.state.tx.us/elections/voter/county.shtml',
            },
            {
              id: '57ed552a-052f-463f-96c3-fc46754f50e0',
              email: 'coe_vote@state.de.us',
              phone: '(302) 739-4277',
              'office-name': 'Delaware',
              'homepage-url': 'https://elections.delaware.gov/index.shtml',
              'ocd-division': [
                'ocd-division/country:us/state:de',
                'Delaware',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          'You will be asked to show ID to vote in Delaware. Acceptable forms include: Delaware Drivers License or State ID; US passport; signed polling place or Social Security Card; signed vehicle registration; signed credit card with photo; or a similar document that identifies the person by photo or signature.\n\nVoters without ID: If you are unable to provide ID, you will be asked to sign an affidavit of affirmation that you are the person listed on the election district record.',
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': true,
                      'acceptable-forms': [{ name: 'de_absentee' }],
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "Your completed voter registration form must contain your Delaware-issued driver's license number or nonoperating identification number. If you do not have a driver's license or nonoperating identification, you must include the last four digits of your Social Security number. If you do not have a driver's license or a nonoperating identification or a Social Security number, please write \"NONE\" on the form. A unique identifying number will be assigned by the State.",
                        signature:
                          'You may register to vote in Delaware if you:\nare a citizen of the United States, and\nare a resident of Delaware; (Delaware is your home), and\nwill be 18 years old on or before the date of the next general election.\nhave NOT been adjudged mentally incompetent. (Adjudged mentally incompetent refers to a specific finding in a judicial guardianship or equivalent proceeding, based on clear and convincing evidence that the individual has a severe cognitive impairment which precludes exercise of basic voting judgment); and\nhave NOT been convicted of a felony, unless you have completed your sentence; and\nhave NOT been convicted of a disqualifying felony and have not been pardoned. (List of disqualifying felonies: murder or manslaughter (except vehicular homicide); any felony constituting an offense against public administration involving bribery or improper influence or abuse of office, or any like offense under the laws of any state or local jurisdiction, or of the United States, or of the District of Columbia; or any felony constituting a sexual offense, or any like offense under the laws of any state or local jurisdiction or of the United States or of the District of Columbia.)',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    {
                      url: 'https://ivote.de.gov/voterregterms.aspx',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need either a Delaware ID or your Social Security number to use Delaware's online voter registration system. If you choose not to provide this information, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://ivote.de.gov/voterlogin.aspx',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2neRAF0',
                },
              ],
              'official-title': 'State Election Commissioner',
              'physical-address': {
                zip: '19904',
                city: 'Dover',
                state: 'DE',
                street: '905 S. Governors Ave Suite 170',
                'routing-code': '19904',
              },
              'polling-place-url': 'https://ivote.de.gov/voterlogin.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2neRAF0',
              'local-reg-authority-lookup-url':
                'https://elections.delaware.gov/locations.shtml',
              'local-election-authority-lookup-url':
                'https://elections.delaware.gov/locations.shtml',
            },
            {
              id: '57ed552b-4f4e-4e2f-9683-9b427fafc7f7',
              email: 'sos@sos.iowa.gov',
              phone: '(888) 767-8683',
              'office-name': 'Iowa',
              'homepage-url':
                'https://sos.iowa.gov/elections/voterinformation/index.html',
              'ocd-division': [
                'ocd-division/country:us/state:ia',
                'Iowa',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'ia_absentee' }],
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          'Identification: Pre-registered voters are required to provide an approved form of ID before casting a regular ballot. Approved forms of ID for pre-registered voters include an Iowa driver’s license or non-operator ID, US passport, tribal ID, US military or veteran ID, or an Iowa voter ID card.\n\nIf you are registering to vote at the polls on election day, you must provide a current and valid photo ID. Approved forms of identification for election day registrants include the items listed above, excluding the Iowa Voter ID Card. Additional acceptable forms of identification are an out-of-state driver’s license or non-operator ID, employer-issued ID, or student ID issued by an Iowa high school or college.\n\nProof of residence: If your address has changed or you need to register at the polls on election day, you will also be required to provide proof of residence. If your current address is on your current and valid ID, then it may also serve as proof of residence. Proof of residence documents must include the voter’s name and address and be current within 45 days of presentation. These documents may be in an electronic format, such as on a cell phone or tablet. Additional approved proof of residence documents are a residential lease, utility bill (including a cell phone bill), bank statement, paycheck, government check or other government document, or a property tax statement (current within 45 days of final payment date).\n\nVoters without ID: A voter who is unable to provide an approved form of identification (or is unable to prove residence, if required) may 1) have their identity/residence attested to by another registered voter in the precinct, or 2) cast a provisional ballot and can provide ID up until the time of the county canvass of votes (Monday after election day for Primary and General Elections).',
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "Your ID number is your Iowa driver's license number (or Iowa non-operator's identification number) if you have one, if not then the last four digits of your Social Security number. The ID number you provide will be verified with the Iowa Department of Transportation or the Social Security Administration.",
                        signature:
                          'To register in Iowa you must: \nbe a citizen of the United States \nbe a resident of Iowa \nbe at least 17 (you must be 18 to vote) \nnot have been convicted of a felony (or have had your rights restored) \nnot currently be judged by a court to be "incompetent to vote" \nnot claim the right to vote in more than one place \ngive up your right to vote in any other place',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    { type: 'election-day' },
                    {
                      url: 'https://mymvd.iowadot.gov/Account/Login?ReturnUrl=%2fVoterRegistration',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need an Iowa ID to use Iowa's online voter registration system. If you don't have an Iowa-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': true,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://sos.iowa.gov/elections/voterreg/regtovote/search.aspx',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2qGZues',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '50319',
                city: 'Des Moines',
                state: 'IA',
                street: 'First Floor, Lucas Building, 321 E. 12th St.',
                'routing-code': '50319',
              },
              'polling-place-url':
                'https://sos.iowa.gov/elections/voterreg/pollingplace/search.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2m2WG7h',
              'local-reg-authority-lookup-url':
                'https://sos.iowa.gov/elections/auditors/auditorslist.html',
              'local-election-authority-lookup-url':
                'https://sos.iowa.gov/elections/auditors/auditorslist.html',
            },
            {
              id: '57ed552b-a21e-4ee7-b5c2-28196d7dc03c',
              email: 'info.sbe@maryland.gov',
              phone: '(410) 269-2840',
              'office-name': 'Maryland',
              'homepage-url': 'https://elections.maryland.gov/',
              'ocd-division': [
                'ocd-division/country:us/state:md',
                'Maryland',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "If you've voted in Maryland before, you don't need to provide ID to vote.\n\nIf you're a first-time voter who registered by mail, and didn't provide a copy of your Maryland driver's license, state or federal ID card, student, employee, or military ID, or a current utility bill, bank statement, government check, paycheck, or government document that shows your name and address when you registered, you may need to show one of these documents to vote.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot. For your ballot to count, you must provide ID to your local board of elections before 10 am on the 2nd Wednesday after election day.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'md_absentee' }],
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      url: 'https://voterservices.elections.maryland.gov/OnlineVoterRegistration/InstructionsStep1',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Maryland ID to use Maryland's online voter registration system. If you don't have a Maryland-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "If you have a current, valid Maryland driver's license or a Motor Vehicle Administration identification card, you must enter the driver's license or identification number. If you do not have a current, valid Maryland driver's license or Motor Vehicle Administration identification card, you must enter at least the last 4 digits of your Social Security number. However, please note, the disclosure of your full Social Security number is voluntary. The statutory authority allowing election officials to request your full Social Security number is Election Law Article, Section 3-202, Annotated Code of Maryland. The number will be used only for registration and other administrative purposes. It will be kept confidential.",
                        signature:
                          'To register in Maryland you must: \nbe a U.S. citizen \nbe a Maryland resident \nbe at least 16 years old, but at least 18 years old to vote \nnot be under guardianship for mental disability \nnot have been convicted of buying or selling votes \nnot have been convicted of a felony, or if you have, you have completed serving a court-ordered sentence of imprisonment, including any term of parole or\nprobation for the conviction.',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    { type: 'election-day' },
                  ],
                  'voter-registration-status-url':
                    'https://voterservices.elections.maryland.gov/votersearch',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2m2HKWy',
                },
              ],
              'official-title': 'State Board of Elections',
              'physical-address': {
                zip: '21401',
                city: 'Annapolis',
                state: 'MD',
                street: '151 West Street, Suite 200',
                'routing-code': '21401',
              },
              'polling-place-url':
                'https://voterservices.elections.maryland.gov/votersearch',
              'polling-place-url-shortened': 'https://tvote.org/2m2HKWy',
              'local-reg-authority-lookup-url':
                'https://elections.maryland.gov/about/county_boards.html',
              'local-election-authority-lookup-url':
                'https://elections.maryland.gov/about/county_boards.html',
            },
            {
              id: '57ed552d-fc90-489f-a963-e21e9282fd46',
              phone: '405-521-2391',
              'office-name': 'Oklahoma',
              'homepage-url': 'https://www.ok.gov/elections/',
              'ocd-division': [
                'ocd-division/country:us/state:ok',
                'Oklahoma',
                {
                  'voting-methods': [
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'ok_absentee' }],
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will need to show ID to vote in Oklahoma. You may show your Voter Identification card issued to you by your County Election Board. You may also show any document issued by the United States, the State of Oklahoma, or a federally recognized tribal government if it includes your name (must substantially match your name in the precinct registry), a photo, and an expiration date that is later than the election in which you are voting. Acceptable forms include: Oklahoma driver's license; Oklahoma ID Card; US passport; tribal ID; or US military ID.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot and prove your identity by signing a sworn affidavit.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          'You must provide one of these numbers: either your valid Oklahoma driver’s license number or state identification card number or the last four digits of your Social Security number.',
                        signature:
                          'To register in Oklahoma you must: \nbe a citizen of the United States and a resident of the State of Oklahoma \nbe 18 years old or older on or before the date of the next election \nif convicted of a felony, you must have fully served the sentence of court-mandated calendar days, including any term of incarceration, parole, or supervision, or completed a period of probation ordered by any court\nnot now be under judgment as an incapacitated person, or a partially incapacitated person prohibited from registering to vote\nmust submit the printed, signed, dated voter registration application. The signature must be the original, handwritten autograph or mark of the applicant. No one may sign on the applicant’s behalf, and no facsimile, reproduction, typewritten, electronic or other substitute signature, autograph, or mark will be valid.',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://okvoterportal.okelections.us/',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/32uvpin',
                },
              ],
              'official-title': 'State Election Board',
              'physical-address': {
                zip: '73105',
                city: 'Oklahoma City',
                state: 'OK',
                street: '2300 N Lincoln Blvd, Room G28, State Capitol Building',
                'routing-code': '73105',
              },
              'polling-place-url': 'https://okvoterportal.okelections.us/',
              'polling-place-url-shortened': 'https://tvote.org/32uvpin',
              'local-reg-authority-lookup-url':
                'https://www.ok.gov/elections/documents/cebinfo.pdf',
              'local-election-authority-lookup-url':
                'https://www.ok.gov/elections/documents/cebinfo.pdf',
            },
            {
              id: '57ed552d-2ccd-4b61-8e4b-a2c63ec266de',
              email: 'elections.sos@oregon.gov​',
              phone: '503-986-1518',
              'office-name': 'Oregon',
              'homepage-url':
                'https://sos.oregon.gov/voting-elections/pages/default.aspx',
              'ocd-division': [
                'ocd-division/country:us/state:or',
                'Oregon',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: true,
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          'Federal law requires that you provide your driver\'s license number to register to vote. If you do not have a driver\'s license then you will have to provide at least the last four digits of your Social Security number. If you have neither, you will need to write "NONE" on the form. A unique identifying number will instead be assigned to you by your State.',
                        signature:
                          'To register in Oregon you must: \nbe a citizen of the United States \nbe a resident of Oregon \nbe at least 16 years old to register, and 18 years old by election day to vote',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    {
                      url: 'https://sos.oregon.gov/voting/Pages/registration.aspx?lang=en',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need an Oregon ID to use Oregon's online voter registration system. If you need to update your registration, please click through to the Oregon site, then scroll down to “Already Registered to Vote?” and click “My Vote” to do so.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://secure.sos.state.or.us/orestar/vr/showVoterSearch.do',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2lZ3O3u',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '97310',
                city: 'Salem',
                state: 'OR',
                street: 'Public Service Building Suite 501, 255 Capitol St. NE',
                'routing-code': '97310',
              },
              'polling-place-url':
                'https://secure.sos.state.or.us/orestar/vr/showVoterSearch.do',
              'polling-place-url-shortened': 'https://tvote.org/2lZ3O3u',
              'local-reg-authority-lookup-url':
                'https://sos.oregon.gov/elections/Pages/countyofficials.aspx',
              'local-election-authority-lookup-url':
                'https://sos.oregon.gov/elections/Pages/countyofficials.aspx',
            },
            {
              id: '57ed552a-8ce5-4998-9e3a-387e8b5803ff',
              phone: '(800) 274-8683',
              'office-name': 'Alabama',
              'homepage-url': 'https://sos.alabama.gov/alabama-votes',
              'ocd-division': [
                'ocd-division/country:us/state:al',
                'Alabama',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will need to show photo ID to vote in Alabama. Acceptable forms of valid photo ID include: Alabama driver's license (may be expired up to 60 days); Alabama non-driver's ID card (may be expired up to 60 days); valid student or employee ID issued by a state institution of higher learning from any state; Alabama photo voter ID card; photo ID card issued by Alabama or any other state; federal government issued ID; US passport; employee ID card issued by the federal government, the State of Alabama, county, municipality, board or other entity in Alabama; student or employee ID issued by a public or private college or university in Alabama; US military ID; or a valid tribal ID.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot. In order for your ballot to be counted, you must provide your ID, including your address and your telephone number, to the board of registrars no later than 5:00 P.M. on the Friday following the election. If you fail to provide ID to the board of registrars by that time, your ballot will not be counted. In addition, voters who do not show valid photo ID at the polls can vote a regular ballot if they are positively identified by two election officials as a voter on the poll list who is eligible to vote and the election officials sign a sworn affidavit.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': true,
                      'acceptable-forms': [{ name: 'al_absentee' }],
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        race: 'You are required to fill in this box; however, your application will not be rejected if you fail to do so.',
                        idnumber:
                          "If you have one, you must provide your Alabama driver's license number or Alabama non-driver's identification card number. If you do not have an Alabama driver's license or non-driver's identification card, you must provide the last 4 digits of your Social Security number. If you have not been issued any of these numbers you must write the word \"NONE\" and a unique identifier will be provided for you.",
                        signature:
                          'To register in Alabama you must: \nbe a citizen of the United States\nbe a resident of Alabama and your county at the time of registration \nbe 18 years old before any election \nnot have been convicted of a felony punishable by imprisonment in the penitentiary (or have had your civil and political rights restored). The list of moral turpitude felonies is available on the Secretary of State web site at: <a href="http://www.sos.alabama.gov/mtfelonies" target="_blank">sos.alabama.gov/mtfelonies</a>\nnot currently be declared mentally incompetent through a competency hearing \nswear or affirm to "support and defend the Constitution of the U.S. and the State of Alabama and further disavow any belief or affiliation with any group which advocates the overthrow of the governments of the U.S. or the State of Alabama by unlawful means and that the information contained herein is true, so help me God"',
                      },
                      'acceptable-forms': [
                        { name: 'nvrf', fields: { race: 'required' } },
                      ],
                    },
                    {
                      url: 'https://www.alabamainteractive.org/sos/voter_registration/voterRegistrationWelcome.action',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need an Alabama ID to use Alabama's online voter registration system. If you don't have an Alabama-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://myinfo.alabamavotes.gov/VoterView/RegistrantSearch.do',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2n6I9rS',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '36130',
                city: 'Montgomery',
                state: 'AL',
                street:
                  'State Capitol Building - Suite E-208, 600 Dexter Avenue',
                'routing-code': '36130',
              },
              'polling-place-url':
                'https://myinfo.alabamavotes.gov/VoterView/PollingPlaceSearch.do',
              'polling-place-url-shortened': 'https://tvote.org/2vpstWF',
              'local-reg-authority-lookup-url':
                'https://www.sos.alabama.gov/city-county-lookup/bor',
              'local-election-authority-lookup-url':
                'https://www.sos.alabama.gov/city-county-lookup/absentee-election-manager',
            },
            {
              id: '57ed552e-799d-4310-aa2d-6d9e56709ad0',
              phone: '(801) 538-1041',
              'office-name': 'Utah',
              'homepage-url': 'https://elections.utah.gov/',
              'ocd-division': [
                'ocd-division/country:us/state:ut',
                'Utah',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will need to show ID to vote in Utah. You can show either ONE photo ID or TWO non-photo IDs.\n\nAcceptable forms of photo ID include: Utah driver's license; ID card issued by the state or a branch, department, or agency of the United States; Utah permit to carry a concealed weapon; US passport; or a tribal ID card (doesn't need photo). Non-photo IDs should should show your name and address. Acceptable forms include: current utility bill dated within 90 days before the election; bank or other financial account statement; certified birth certificate; Social Security card; a check issued by the state or federal government; paycheck; Utah hunting or fishing license; US military ID card; certified naturalization documents, but not a green card; a certified copy of court records showing your adoption or name change; Bureau of Indian Affairs card; a tribal treaty card; Medicaid or Medicare or Electronic Benefits Transfer card; ID card issued by a local government within Utah; ID card issued by your employer; ID card issued by a college, university, technical school or professional school within Utah; or a current Utah vehicle registration.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot and must bring an ID to the elections office by the close of normal office hours on Monday after the date of the election.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'ut_absentee' }],
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          'Your completed voter registration form must contain your Utah Driver License number, a Utah State Identification number, or the last four digits of your Social Security number. If you do not have a Utah Driver License or a Utah State Identification card, please write "None" in the designated space and fill in the last four digits of your Social Security number.',
                        signature:
                          'To register in Utah you must: \nbe a citizen of the United States \nhave resided in Utah for 30 days immediately before the next election \n be at least 18 years old on or before the next election (individuals who are 16 and 17 years of age may pre-register to vote; if a 17 year old will be 18 years of age on or before the upcoming general election, they may pre-register and vote in the primary election)\nnot be a convicted felon currently incarcerated for commission of a felony \nnot be convicted of treason or crime against the elective franchise, unless restored to civil rights \nnot be found to be mentally incompetent by a court of law\ncurrently reside within the voting district or precinct in which you register to vote',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    { type: 'election-day' },
                    {
                      url: 'https://secure.utah.gov/voterreg/index.html',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Utah ID to use Utah's online voter registration system. The address on the ID needs to match the address where you're registering to vote. If you don't have a Utah-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://votesearch.utah.gov/voter-search/search/search-by-voter/voter-info',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2FZCfVd',
                },
              ],
              'official-title': 'Lieutenant Governor',
              'physical-address': {
                zip: '84114',
                city: 'Salt Lake City',
                state: 'UT',
                street: 'Utah State Capitol Complex, Suite 220',
                'routing-code': '84114',
              },
              'polling-place-url':
                'https://votesearch.utah.gov/voter-search/search/search-by-address/how-and-where-can-i-vote',
              'polling-place-url-shortened': 'https://tvote.org/2FRbNeX',
              'local-reg-authority-lookup-url':
                'https://elections.utah.gov/election-resources/county-clerks',
              'local-election-authority-lookup-url':
                'https://elections.utah.gov/election-resources/county-clerks',
            },
            {
              id: '57ed552c-5952-46db-ac11-be9c5969cda1',
              email: 'elections@sos.nh.gov',
              phone: '603-271-3242',
              'office-name': 'New Hampshire',
              'homepage-url': 'http://sos.nh.gov/Elections.aspx',
              'ocd-division': [
                'ocd-division/country:us/state:nh',
                'New Hampshire',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will be requested to show photo ID to vote in New Hampshire. Acceptable forms include (the name on the ID must be substantially similar to the voter registration record and the expiration date cannot exceed five years): a driver's license from any state; a non-driver's ID issued by the motor vehicle agency of any state; a photo ID card for “voting identification only” issued by NH DMV; a US armed services ID card; a student ID from an accredited college, university, or career school in New Hampshire, a New Hampshire public high school, an accredited private high school in New Hampshire, Dartmouth College, and any college or university operated by the university or community college systems of New Hampshire; or a US passport or passcard.\n\nIf you are registering to vote at the polls on election day, you will also need to show proof of citizenship and domicile (that you live in New Hampshire). For proof of citizenship, you can show a birth certificate, US passport or passcard, or naturalization documents, or you can sign an affidavit. You cannot use your New Hampshire driver's license as proof of citizenship. For proof of domicile, you must show an official document that includes your name and address. Acceptable documents include: a driver's license or non-driver's ID, a document from your school, a note signed by a school official or RA, a residential lease, a deed or property tax bill, a motor vehicle registration, a voter photo ID, a public school enrollment, a tax form or other official government form, a form from the US Postal Service (your address cannot be a PO Box), a utility bill, a note from a homeless shelter that confirms they will receive mail sent to you at their address, or a note from the person who owns or supervises the property where you live if it includes the statement \"providing false information is a violation of New Hampshire law under penalty of voting fraud.\"\n\nVoters without ID: If you are unable to provide ID, you can either have your identity verified by a voting official at your voting location, or sign an affidavit and be photographed by a voting official at your voting location before you vote (if you object to being photographed for religious reasons, you can sign an additional affidavit of religious exemption instead). If you are registering to vote on election day and do not have a proof of domicile, you can sign an affidavit. You will then need to provide the document to your town or city clerk within 10 days after the election, or state that you do not have any proof of domicile and understand that town officials will work to confirm where you live.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': true,
                    },
                  ],
                  'election-authority-level': 'municipal',
                  'voter-registration-methods': [
                    { type: 'call-clerk' },
                    { type: 'election-day' },
                  ],
                  'voter-registration-status-url':
                    'https://app.sos.nh.gov/Public/PartyInfo.aspx',
                  'voter-registration-authority-level': 'municipal',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mmaj3K',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '03301',
                city: 'Concord',
                state: 'NH',
                street: 'State House, Room 204, 107 North Main Street',
                'routing-code': '03301',
              },
              'polling-place-url':
                'https://app.sos.nh.gov/Public/PollingPlaceSearch.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2mm8oMy',
              'local-reg-authority-lookup-url':
                'https://app.sos.nh.gov/Public/ClerkDetails.aspx',
              'local-election-authority-lookup-url':
                'https://app.sos.nh.gov/Public/ClerkDetails.aspx',
            },
            {
              id: '57ed552b-1a14-4c3b-b5d5-0739a400dcdb',
              phone: '502-573-7100',
              'office-name': 'Kentucky',
              'homepage-url': 'https://elect.ky.gov/Pages/default.aspx',
              'ocd-division': [
                'ocd-division/country:us/state:ky',
                'Kentucky',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will need to show ID, or be known personally by a precinct election officer, to vote in Kentucky. Acceptable forms include: driver's license; Social Security card; ID issued by the US government; ID issued by the Kentucky government with picture; credit card; county-issued ID card approved in writing by the State Board of Elections; or another form of ID containing both picture and signature.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': true,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          'Your full Social Security number is required. It is used for administrative purposes only and is not released to the public (KRS 116.155). No person shall be denied the right to register because of failure to include Social Security number.',
                        signature:
                          'To register in Kentucky you must: \nbe a citizen of the United States \nbe a resident of Kentucky \nbe a resident of the county for at least 28 days prior to the election date \nbe 18 years of age on or before the next general election \nnot be a convicted felon or if you have been convicted of a felony, your civil rights must have been restored by executive pardon \nnot have been judged "mentally incompetent" in a court of law \nnot claim the right to vote anywhere outside Kentucky',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    {
                      url: 'https://vrsws.sos.ky.gov/ovrweb/',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Social Security number to use Kentucky's online voter registration system. If you don't have a Social Security number, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://vrsws.sos.ky.gov/ovrweb/govoteky',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mjwCFQ',
                },
              ],
              'official-title': 'State Board of Elections',
              'physical-address': {
                zip: '40601',
                city: 'Frankfort',
                state: 'KY',
                street: '140 Walnut Street',
                'routing-code': '40601',
              },
              'polling-place-url': 'https://vrsws.sos.ky.gov/VIC/',
              'polling-place-url-shortened': 'https://tvote.org/2mjwCFQ',
              'local-reg-authority-lookup-url':
                'https://elect.ky.gov/About-Us/Pages/County-Clerks.aspx',
              'local-election-authority-lookup-url':
                'https://elect.ky.gov/contactcountyclerks/Pages/default.aspx',
            },
            {
              id: '57ed552b-cf55-4575-940b-154af4113b94',
              email: 'elections@sec.state.ma.us',
              phone: '617-727-2828',
              'office-name': 'Massachusetts',
              'homepage-url': 'https://www.sec.state.ma.us/ele/',
              'ocd-division': [
                'ocd-division/country:us/state:ma',
                'Massachusetts',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You may be asked to show identification if: you are voting for the first-time in Massachusetts in a federal election, you are an inactive voter, you are casting a provisional or challenged ballot, or if the poll worker has a reasonable suspicion that leads them to request identification. Acceptable forms include (must show your name and address): a MA driver's license or MA-issued ID card; recent utility bill; rent receipt; signed lease; a copy of a voter registration affidavit; or any other printed identification which contains the voter's name and address.\n\nVoters without ID: If you're a first-time voter who is unable to present ID when you check in, you may vote a provisional ballot and return with acceptable ID by close of polls. If you're asked for ID for any other reason, and are not able to present ID in such a situation, you must still be permitted to vote; however, your ballot must be challenged. Your ballot will be cast normally, and will only be re-examined in the case of a recount, court order, or audit.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': true,
                      'acceptable-forms': [{ name: 'ma_absentee' }],
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'municipal',
                  'voter-registration-methods': [
                    {
                      url: 'https://www.sec.state.ma.us/OVR/Pages/MinRequirements.aspx?RMVId=True',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need an ID issued by the Massachusetts Registry of Motor Vehicles. If you don't have an ID issued by the Massachusetts Registry of Motor Vehicles, you can still register to vote by mail.",
                      },
                      'supports-iframe': true,
                    },
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          'Federal law requires that you provide your driver\'s license number to register to vote. If you do not have a current and valid Massachusetts driver\'s license, you must provide the last four digits of your Social Security number. If you have neither, you must write "NONE" in the box  and a unique identifying number will be assigned to you.',
                        signature:
                          'To register in Massachusetts you must: \nbe a citizen of the United States \nbe a resident of Massachusetts \nbe at least 16 years old (must be 18 years old to vote on Election Day)\nnot have been convicted of corrupt practices in respect to elections \nnot be under guardianship with respect to voting \nnot be currently incarcerated for a felony conviction',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://www.sec.state.ma.us/VoterRegistrationSearch/MyVoterRegStatus.aspx',
                  'voter-registration-authority-level': 'municipal',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mBZdbH',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '02108',
                city: 'Boston',
                state: 'MA',
                street: 'McCormack Building, One Ashburton Place, Room 1705',
                'routing-code': '02108',
              },
              'polling-place-url':
                'https://www.sec.state.ma.us/wheredoivotema//bal/myelectioninfo.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2v2xAee',
              'local-reg-authority-lookup-url':
                'https://www.sec.state.ma.us/ele/eleclk/clkidx.htm',
              'local-election-authority-lookup-url':
                'https://www.sec.state.ma.us/ele/eleclk/clkidx.htm',
            },
            {
              id: '57ed552c-42df-4f6e-9d79-aaf6b91c0686',
              phone: '(406) 444-2034',
              'office-name': 'Montana',
              'homepage-url': 'https://sosmt.gov/elections/',
              'ocd-division': [
                'ocd-division/country:us/state:mt',
                'Montana',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          'You will be asked to show ID to vote in Montana. Acceptable forms include: a current photo ID showing your name; or a current utility bill, bank statement, paycheck, voter registration confirmation, government check or other government document showing your current name and address.\n\nVoters without ID: If you are unable to provide ID, you can still vote by requesting and filling out a "Polling Place Elector ID" form. Or, you can vote a provisional ballot. Your provisional ballot will be counted if you provide one of the items on the list to the county election office by 5:00 p.m. the day after the election, or mail it to the county election office postmarked by the day after the election.',
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'mt_absentee' }],
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "You must provide your Montana driver's license number. If you do not have a Montana driver's license number then you must list the LAST FOUR DIGITS OF YOUR SOCIAL SECURITY NUMBER. If you have neither a driver's license, nor a social security number, please write “NONE” on the form and include a copy of one of the following alternative forms of identification: a current and valid photo identification, including but not limited to a school district or postsecondary education photo identification or a tribal photo identification, with your name; or a current utility bill, bank statement, paycheck, government check, or other government document that shows your name and current address.",
                        signature:
                          'To register in Montana you must: \nbe a citizen of the United States \nbe at least 18 years old on or before the election \nbe a resident of Montana and of the county in which you want to vote for at least 30 days before the next election \nnot be in a penal institution for a felony conviction \nnot currently be determined by a court to be of unsound mind \nmeet these qualifications by the next election day if you do not currently meet them',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://app.mt.gov/voterinfo/',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2nfbQqc',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '59620',
                city: 'Helena',
                state: 'MT',
                street: 'Montana Capitol Building, Rm 260',
                'routing-code': '59620',
              },
              'polling-place-url': 'https://app.mt.gov/voterinfo/',
              'polling-place-url-shortened': 'https://tvote.org/2nfbQqc',
              'local-reg-authority-lookup-url':
                'https://sosmt.gov/Portals/142/Elections/Forms/electionadministrators.pdf',
              'local-election-authority-lookup-url':
                'https://sosmt.gov/Portals/142/Elections/Forms/electionadministrators.pdf',
            },
            {
              id: '57ed552e-940c-4262-9dbd-62ed95464677',
              email: 'elections@sos.ri.gov',
              phone: '(401) 222-2340',
              'office-name': 'Rhode Island',
              'homepage-url': 'https://vote.sos.ri.gov/',
              'ocd-division': [
                'ocd-division/country:us/state:ri',
                'Rhode Island',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': true,
                      'acceptable-forms': [{ name: 'ri_absentee' }],
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will be asked to show photo ID to vote in Rhode Island. Acceptable forms ID include: Rhode Island driver's license; Rhode Island voter ID card; US passport; ID issued by a school or college in the US; US military ID; ID issued by the US government or State of Rhode Island; tribal ID; or a government-issued medical photo ID. \n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot. The voter has until the close of business the day after the election to provide information to the Board of Canvassers to help qualify their ballot.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'municipal',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "The applicant shall be required to provide their Rhode Island driver's license number or Rhode Island-issued ID number if the applicant has been issued a current and valid Rhode Island driver's license or Rhode Island-issued ID. In the case of an applicant who has not been issued a current and valid Rhode Island driver's license or Rhode Island-issued ID, they must provide the last four (4) digits of their Social Security number. An applicant who has neither will be assigned a unique identifying number by the State of Rhode Island.",
                        signature:
                          'To register in Rhode Island you must: \nbe a citizen of the United States \nbe a resident of Rhode Island \nbe at least 16 years of age (You must be at least 18 years of age to vote on Election Day.) \nnot be currently incarcerated in a correctional facility due to a felony conviction \nnot have been lawfully judged to be mentally incompetent',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    {
                      url: 'https://vote.sos.ri.gov/ovr',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Rhode Island ID to use Rhode Island's online voter registration system. If you don't have a Rhode Island-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url': 'https://vote.sos.ri.gov/',
                  'voter-registration-authority-level': 'municipal',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2LAptQp',
                },
              ],
              'official-title': 'Department of State’s Election Division',
              'physical-address': {
                zip: '02904',
                city: 'Providence',
                state: 'RI',
                street: '148 West River Street',
                'routing-code': '02904',
              },
              'polling-place-url': 'https://vote.sos.ri.gov',
              'polling-place-url-shortened': 'https://tvote.org/2LAptQp',
              'local-reg-authority-lookup-url':
                'https://vote.sos.ri.gov/ovr/info/local_boards',
              'local-election-authority-lookup-url':
                'https://vote.sos.ri.gov/ovr/info/local_boards',
            },
            {
              id: '57ed552b-0f28-4bea-992e-4d240062ad52',
              phone: '225-922-0900',
              'office-name': 'Louisiana',
              'homepage-url':
                'https://www.sos.la.gov/ElectionsAndVoting/Pages/default.aspx',
              'ocd-division': [
                'ocd-division/country:us/state:la',
                'Louisiana',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': true,
                      'acceptable-forms': [{ name: 'la_absentee' }],
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will be asked to show photo ID to vote in Louisiana. Acceptable forms of photo ID include: a Louisiana driver's license or special ID card; LA Wallet digital driver's license; or some other generally recognized picture ID that contains your name and signature, like a passport.\n\nVoters without ID: If you are unable to provide ID, you may still cast your vote by signature on a voter affidavit.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        race: 'Completing this box is optional.',
                        idnumber:
                          "You must provide your LA driver's license number or LA special ID card number, if issued. If not issued, you must provide at least the last 4 digits of your Social Security number (SSN), if issued. The full SSN may be provided on a voluntary basis. If the applicant has neither a LA driver's license, a LA special ID card, or a SSN, the applicant shall attach one of the following items to his application: (a) a copy of a current and valid photo ID; or (b) a copy of a current utility bill, bank statement, government check, paycheck, or other government document that shows the name and address of applicant. Neither the registrar nor the Department of State shall disclose the SSN of a registered voter or circulate the SSNs of registered voters on commercial lists (R.S. 18:104 and 154; 42 U.S.C. Sec. 405).",
                        signature:
                          "To register in Louisiana you must: \nbe a citizen of the United States \nbe a resident of Louisiana (Residence address must be address where you claim homestead exemption, if any, except for a resident in a nursing home or veteran's home who may select to use the address of the nursing home or veterans' home or the home where he has a homestead exemption. A college student may elect to use his home address or his address while away at school.) \nbe at least 17 years old to register by mail (16 years old to register in person at the registrar of voters office or at the Louisiana Office of Motor Vehicles), and be 18 years old prior to the next election to vote \nnot currently be under an order of imprisonment for conviction of a felony or if under such an order (1) not have been incarcerated pursuant to the order within the last five years and (2) not be under an order of imprisonment related to a felony conviction for election fraud or any other election offense pursuant to R.S. 18:1461.2\nnot be under a judgment of full interdiction for mental incompetence or limited interdiction where your right to vote has been suspended",
                      },
                      'acceptable-forms': [
                        { name: 'nvrf', fields: { race: 'requested' } },
                      ],
                    },
                    {
                      url: 'https://www.sos.la.gov/ElectionsAndVoting/Pages/OnlineVoterRegistration.aspx',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Louisiana ID to use Louisiana's online voter registration system. If you don't have a Louisiana-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://voterportal.sos.la.gov/',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2OTjV2y',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '70809',
                city: 'Baton Rouge',
                state: 'LA',
                street: '8585 Archives Ave',
                'routing-code': '70809',
              },
              'polling-place-url':
                'https://voterportal.sos.la.gov/Home/VoterLogin',
              'polling-place-url-shortened': 'https://tvote.org/2lEsseo',
              'local-reg-authority-lookup-url':
                'https://voterportal.sos.la.gov/Registrar',
              'local-election-authority-lookup-url':
                'https://voterportal.sos.la.gov/Registrar',
            },
            {
              id: '57ed552b-7ca5-4699-9fc3-9bfa06e6e3eb',
              phone: '(517) 373-2540',
              'office-name': 'Michigan',
              'homepage-url':
                'https://www.michigan.gov/sos/0,8611,7-127-1633---,00.html',
              'ocd-division': [
                'ocd-division/country:us/state:mi',
                'Michigan',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will be asked to show current photo ID to vote in Michigan. Acceptable forms include: Michigan driver's license or state ID card; current (non-expired) driver's license or personal ID card issued by another state; federal or state government-issued photo ID; US passport; military ID card with a photo; tribal ID card with a photo; or a student ID with a photo from a high school or an accredited institution of higher education; Tribal identification card with photo.\n\nVoters without ID: If you are unable to provide ID, you can vote like any other voter by signing an affidavit.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'mi_absentee' }],
                    },
                  ],
                  'election-authority-level': 'municipal',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "Your completed voter registration form must contain your state issued driver's license number or state issued personal identification card number. If you do not have a driver's license or state issued personal identification card, you must include the last four digits of your social security number. If you do not have a driver's license or a state issued personal identification card or a social security number, please write \"NONE\" on the form. A unique identifying number will be assigned by the State.",
                        signature:
                          'To register in Michigan you must: \nbe a citizen of the United States \nbe 18 years old by the next election \nbe a resident of Michigan and at least a 30 day resident of your city or township by election day \nnot be confined in a jail after being convicted and sentenced',
                        'citizenship-docs':
                          "Notice: Michigan law requires that the same address be used for voter registration and driver's license purposes. Therefore, if the residence address you provide on this form differs from the address shown on a driver's license or personal identification card issued by the State of Michigan, the Secretary of State will automatically change your driver's license or personal identification card address to match the residence address entered on this form. If an address change is made, the Secretary of State will mail you an address update sticker for your license or personal identification card.",
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    {
                      url: 'https://mvic.sos.state.mi.us/RegisterVoter',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Michigan ID to use Michigan's online voter registration system. If you don't have a Michigan-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://mvic.sos.state.mi.us/',
                  'voter-registration-authority-level': ['municipal', 'county'],
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mBSHl2',
                },
              ],
              'official-title': 'Secretary of State',
              'mailing-address': {
                zip: '48901-0726',
                city: 'Lansing',
                state: 'MI',
                street: 'PO Box 20126',
                'routing-code': '489010726',
              },
              'physical-address': {
                zip: '48918',
                city: 'Lansing',
                state: 'MI',
                street:
                  'Richard H. Austin Building - First Floor, 430 W. Allegan',
                'routing-code': '48918',
              },
              'polling-place-url': 'https://mvic.sos.state.mi.us/',
              'polling-place-url-shortened': 'https://tvote.org/2mBSHl2',
              'local-reg-authority-lookup-url':
                'https://mvic.sos.state.mi.us/Clerk',
              'local-election-authority-lookup-url':
                'https://mvic.sos.state.mi.us/Clerk',
            },
            {
              id: '57ed552a-e24f-4ea5-bc0d-963f1a64b8cb',
              email: 'lead@ct.gov',
              phone: '860-509-6100',
              'office-name': 'Connecticut',
              'homepage-url':
                'https://portal.ct.gov/SOTS/Common-Elements/V5-Template---Redesign/Elections--Voting--Home-Page',
              'ocd-division': [
                'ocd-division/country:us/state:ct',
                'Connecticut',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': true,
                      'acceptable-forms': [{ name: 'ct_absentee' }],
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You may be asked to show ID to vote in Connecticut. Acceptable forms include: Social Security card; or any other pre-printed form of ID that shows your name and address or name and signature, or name and photograph.\n\nIf you're a first-time voter who registered by mail, you will need to show a proof of residence as well. Acceptable forms include: a current and valid photo ID that shows your name and address; or a copy of a current utility bill, bank statement, government check, paycheck or government document that shows your name and address.\n\nVoters without ID: If you are unable to provide ID, you will be able to sign an affidavit  instead and then vote normally. If you're a first-time voter without ID, you may vote a provisional ballot.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'municipal',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "When you register to vote, you must provide either your Connecticut driver's license number, or if none, the last four digits of your Social Security number.",
                        signature:
                          'To register in Connecticut you must: \nbe a citizen of the United States \nbe a resident of Connecticut and of the town in which you wish to vote \nbe 17 years old. 17 year olds who will turn 18 on or before Election Day, may participate in the general primary\nhave completed confinement and parole if previously convicted of a felony, and have had your voting rights restored by Registrars of Voters\nnot currently be declared mentally incompetent to vote by a court of law',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    {
                      url: 'https://voterregistration.ct.gov/OLVR/welcome.do',
                      type: 'online',
                      instructions: {
                        registration:
                          'You should know: to use the online voter registration system you must have a current and valid driver’s license, learner’s permit or non-driver photo identification card issued by the CT Department of Motor Vehicles (DMV) and a signature on file with DMV.',
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://portaldir.ct.gov/sots/LookUp.aspx',
                  'voter-registration-authority-level': 'municipal',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2vlrgzB',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '06106',
                city: 'Hartford',
                state: 'CT',
                street: '30 Trinity Street',
                'routing-code': '06106',
              },
              'polling-place-url':
                'https://portal.ct.gov/SOTS/Election-Services/Voter-Information/Where-and-how-do-I-vote',
              'polling-place-url-shortened': 'https://tvote.org/2OfkgfA',
              'local-reg-authority-lookup-url':
                'https://portal.ct.gov/-/media/SOTS/ElectionServices/lists/ROVListpdf.pdf?la=en',
              'local-election-authority-lookup-url':
                'https://portal.ct.gov/-/media/sots/ElectionServices/lists/TownClerkListpdf.pdf',
            },
            {
              id: '57ed552a-d505-4c8c-88fb-c355e632fdcc',
              phone: '(602) 542-8683',
              'office-name': 'Arizona',
              'homepage-url': 'https://azsos.gov/elections',
              'ocd-division': [
                'ocd-division/country:us/state:az',
                'Arizona',
                {
                  'voting-methods': [
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You WILL need to show ID to vote in person. This is either ONE photo ID or TWO non-photo ID. Your ID must bear your name and address. \n\nAcceptable forms of valid (non-expired) photo ID include (present 1): Arizona driver's license; Arizona non-driver's identification; tribal enrollment card or other form of tribal identification; US federal, state or local government-issued identification. Acceptable forms of non-photo ID include (present 2, showing your current name and address): utility bill dated within 90 days of the election; bank or credit union statement dated within 90 days of the election; valid Arizona vehicle registration; Indian census card; property tax statement; tribal enrollment card or other form of tribal identification; Arizona vehicle insurance card; recorder's certificate; valid US federal, state, or local government issued identification, including a voter registration card issued by the County Recorder; or any mailing to the elector marked \"Official Election Material\".\n\nIf you are unable to produce 1 photo ID or 2 non-photo IDs, you may show: any valid photo ID with an address that does not match the precinct register accompanied by a non-photo ID with an address that matches the precinct register; US Passport without address and one valid item of non-photo ID; or US Military ID without address and one valid item of non-photo ID.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a conditional provisional ballot. Conditional provisional ballots are counted only if you present ID at your polling location before 7:00 pm on Election Day or at the county elections office within five business days after a general election and three business days after any other election.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'az_absentee' }],
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "Your completed voter registration form must contain the number of your Arizona driver's license, or non-operating identification license issued pursuant to A.R.S. Sec. 28-3165, if the license is current and valid. If you do not have a current and valid Arizona driver's license or non-operating identification license, you must include the last four digits of your Social Security number if one has been issued to you. If you do not have a current and valid driver's license or non-operating identification license or a Social Security number, please write \"NONE\" on the form. A unique identifying number will be assigned by the Secretary of State.",
                        signature:
                          'To register in Arizona you must: \nbe a citizen of the United States \nbe a resident of Arizona and your county at least 29 days preceding the next election \nbe 18 years old on or before the next general election \nnot have been convicted of treason or a felony (or have had your civil rights restored) \nnot currently be declared an incapacitated person by a court of law',
                        'citizenship-docs':
                          "If this is your first time registering to vote in Arizona or you have moved to another county in Arizona, your voter registration form also must include proof of citizenship or you may be registered as a federal-only voter. If you have an Arizona driver's license or non-operating identification issued after October 1, 1996, write the number on the form. This will serve as proof of citizenship and no additional documents are needed. If not, you should attach proof of citizenship to the form. Please include a copy of one of the following documents: birth certificate and supporting legal documentation (i.e. marriage certificate) if the name on the birth certificate is not the same as your current legal name; passport; naturalization documents or fill in your Alien Registration Number; Indian census number, Bureau of Indian Affairs Card Number, Tribal Treaty Card Number, or Tribal Enrollment Number, or your Tribal Certificate of Indian Blood or Tribal or Bureau of Indian Affairs Affidavit of Birth. Do not send original documents. Photocopies will not be returned to you.",
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    {
                      url: 'https://servicearizona.com/webapp/evoter/selectLanguage',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need an Arizona ID to use Arizona's online voter registration system. If you don't have an Arizona-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://voter.azsos.gov/VoterView/RegistrantSearch.do',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mjeHip',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '85007-2808',
                city: 'Phoenix',
                state: 'AZ',
                street: '1700 W Washington St Fl 7',
                'routing-code': '850072808',
              },
              'polling-place-url':
                'https://voter.azsos.gov/VoterView/PollingPlaceSearch.do',
              'polling-place-url-shortened': 'https://tvote.org/2Mr91z9',
              'local-reg-authority-lookup-url':
                'https://azsos.gov/elections/voting-election/contact-information-county-election-officials',
              'local-election-authority-lookup-url':
                'https://azsos.gov/elections/voting-election/contact-information-county-election-officials',
            },
            {
              id: '57ed552c-9715-4275-9fe0-a24c6271f60f',
              email: 'sos.elections@state.nm.us',
              phone: '505-827-3600',
              'office-name': 'New Mexico',
              'homepage-url': 'http://www.sos.state.nm.us/',
              'ocd-division': [
                'ocd-division/country:us/state:nm',
                'New Mexico',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "If you've voted in New Mexico before, you don't need to provide ID to vote.\n\nIf you're a first-time voter who registered by mail, and didn't include a copy of ID when you registered, you will need to show ID to vote. Acceptable forms include: photo ID; student ID card; ID issued by an Indian nation, tribe or pueblo; or a copy of a utility bill, bank statement, government check, paycheck, or other government document that shows your name and current address.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'nm_absentee' }],
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      url: 'https://portal.sos.state.nm.us/OVR/(S(r52ixg1k5n1bltkptf5mthpk))/WebPages/DomesticApplication.aspx',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a New Mexico ID and a Social Security number to use New Mexico's online voter registration system. If you don't have a New Mexico-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          'Your full Social Security number is required. This registration card containing your Social Security number will become part of the permanent voter registration records of your locality, which are open to inspection by the public in the office of the county clerk. However, your Social Security number and date of birth will remain confidential and will not be disclosed to the public. Computerized listings of limited voter registration information (without Social Security number or birth date) are available to the general public, and are furnished upon request to incumbent election officeholders, candidates, political parties, courts and non‑profit organizations promoting voter participation and registration, for political purposes only (Sec.1-5-19B, NMSA 1978).',
                        signature:
                          'To register in New Mexico you must: \nbe a citizen of the United States \nbe a resident of the State of New Mexico \nbe 18 years of age at the time of the next election \nnot have been denied the right to vote by a court of law by reason of mental incapacity and, if convicted of a felony, have completed all conditions of probation or parole, served the entirety of a sentence or have been granted a pardon by the Governor.',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://voterportal.servis.sos.state.nm.us/WhereToVote.aspx',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2DZ9ZgQ',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '87501',
                city: 'Santa Fe',
                state: 'NM',
                street:
                  'New Mexico Capitol Annex North, 325 Don Gaspar, Suite 300',
                'routing-code': '87501',
              },
              'polling-place-url':
                'https://voterportal.servis.sos.state.nm.us/WhereToVote.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2DZ9ZgQ',
              'local-reg-authority-lookup-url':
                'http://www.sos.state.nm.us/Voter_Information/County_Clerk_Information.aspx',
              'local-election-authority-lookup-url':
                'http://www.sos.state.nm.us/Voter_Information/County_Clerk_Information.aspx',
            },
            {
              id: '57ed552e-ac75-4bb3-bde7-08318a820273',
              email: 'elections@state.sd.us',
              phone: '605-773-3537',
              'office-name': 'South Dakota',
              'homepage-url': 'https://sdsos.gov/elections-voting/default.aspx',
              'ocd-division': [
                'ocd-division/country:us/state:sd',
                'South Dakota',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: false,
                      instructions: {
                        'voting-id':
                          "South Dakota requires absentee voters to provide ID with their application.  You'll either need to include a photocopy of your ID with your application or you'll need to have the application notarized or witnessed by an official who can administer an oath.\n  \nAcceptable forms of ID include: A South Dakota driver's license or non-driver ID card, a passport or other picture ID issued by the United States government, a tribal photo ID, or a current student photo ID issued by a South Dakota high school or postsecondary education institution.",
                      },
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'sd_absentee' }],
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will be asked to show photo ID to vote in South Dakota. Acceptable forms include: South Dakota driver's license or non-driver's ID card; US government photo ID (including a passport); US armed forces ID; current student photo ID from a South Dakota high school or South Dakota accredited institution of higher education; or a tribal photo ID.\n\nVoters without ID: If you are unable to provide ID, you can sign a personal identification affidavit and still be allowed to vote a regular ballot.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "Your driver's license number is requested. If you do not have a valid driver's license, you must provide the last four digits of your Social Security number.",
                        signature:
                          'To register in South Dakota you must: \nbe a citizen of the United States \nreside in South Dakota \nbe 18 years old by the next election \nnot be currently serving a sentence for a felony conviction which included imprisonment, served or suspended, in an adult penitentiary system \nnot have been adjudged mentally incompetent by a court',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://vip.sdsos.gov/viplogin.aspx',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2M6VLCV',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '57501',
                city: 'Pierre',
                state: 'SD',
                street: 'Capitol Building, 500 East Capitol Avenue Ste 204',
                'routing-code': '57501',
              },
              'polling-place-url': 'https://vip.sdsos.gov/viplogin.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2M6VLCV',
              'local-reg-authority-lookup-url':
                'https://sdsos.gov/contact-us/county-auditors.aspx',
              'local-election-authority-lookup-url':
                'https://sdsos.gov/contact-us/county-auditors.aspx',
            },
            {
              id: '57ed552e-7962-42f8-b2a7-cf0336cef99c',
              email: 'info@elections.virginia.gov',
              phone: '(804) 864-8901',
              'office-name': 'Virginia',
              'homepage-url': 'https://www.elections.virginia.gov/',
              'ocd-division': [
                'ocd-division/country:us/state:va',
                'Virginia',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will need to show photo ID to vote in Virginia. Acceptable forms of valid ID include: Virginia driver's license or photo ID; Virginia DMV-issued veteran's ID card; US passport or passport card; US military ID; student photo ID issued by a school, college, or university located in Virginia; another photo ID issued by the federal government, Virginia, or a local body of Virginia government; employee photo ID issued by your employer; tribal enrollment or other tribal ID if issued by one of 11 tribes recognized by Virginia; or a Virginia voter photo ID obtained through any local general registrar's office.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot. After completing the provisional ballot, you will be given written instructions from the election officials on how to submit a copy of your ID so that your vote can be counted. You will have until noon on the Friday following the election to deliver a copy of the ID to the local electoral board.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      instructions: {
                        'voting-id':
                          'First-time voters who registered by mail may vote absentee by mail only if the reason code is 1A, 2A, 2C, 6A, 6B, 6C, 6D, or 7A, or the voter is 65 or older and qualifies under another reason. Check with your registrar to confirm absentee by mail eligibility.',
                      },
                      'excuse-required': true,
                      'acceptable-forms': [{ name: 'va_absentee' }],
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          'Your full Social Security number is required. Your Social Security number will appear on reports produced only for official use by voter registration and election officials and, for jury selection purposes, by courts. Article II, Sec.2, Constitution of Virginia (1971).',
                        signature:
                          'To register in Virginia you must: \nbe a citizen of the United States \nbe a resident of Virginia and of the precinct in which you want to vote \nbe 18 years old by the next May or November general election \nnot have been convicted of a felony, or have had your civil rights restored\nnot currently be declared mentally incompetent by a court of law',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    {
                      url: 'https://vote.elections.virginia.gov/Registration/Eligibility',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Virginia ID and a Social Security number to use Virginia's online voter registration system. If you don't have a Virginia-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': true,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://vote.elections.virginia.gov/VoterInformation',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mC7YCD',
                },
              ],
              'official-title': 'Department of Elections',
              'physical-address': {
                zip: '23219',
                city: 'Richmond',
                state: 'VA',
                street: 'Washington Building, 1100 Bank Street, First Floor',
                'routing-code': '23219',
              },
              'polling-place-url':
                'https://vote.elections.virginia.gov/VoterInformation',
              'polling-place-url-shortened': 'https://tvote.org/2mC7YCD',
              'local-reg-authority-lookup-url':
                'https://vote.elections.virginia.gov/VoterInformation/PublicContactLookup',
              'local-election-authority-lookup-url':
                'https://vote.elections.virginia.gov/VoterInformation/PublicContactLookup',
            },
            {
              id: '57ed552a-c18e-4419-80cb-df3755e83bf5',
              phone: '(800) 345-VOTE',
              'office-name': 'California',
              'homepage-url': 'http://www.sos.ca.gov/elections/',
              'ocd-division': [
                'ocd-division/country:us/state:ca',
                'California',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "If you've voted in California before, you don't need to show ID. \n\nIf you're a first-time voter who registered by mail, and didn't include your driver's license number, California ID number, or the last 4 digits of your Social Security number on your registration, you may be asked to provide ID when you vote. Acceptable forms include: copy of a recent utility bill, the sample ballot booklet you received from your county elections office or another document sent to you by a government agency, a US passport, driver license, official state identification card, or student identification card showing your name and photograph.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'ca_absentee' }],
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "When you register to vote, you must provide your California driver's license or California identification card number, if you have one. If you do not have a driver's license or ID card, you must provide the last four digits of your Social Security number (SSN). If you do not include this information, you will be required to provide identification when you vote.",
                        signature:
                          'To register in California you must:\nbe a citizen of the United States\nbe a resident of California\nbe at least 18 or older on Election Day to vote\nnot be currently in state or federal prison or on parole for the conviction of a felony \nnot be currently found to be mentally incompetent to vote by a court',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    {
                      url: 'https://registertovote.ca.gov/',
                      type: 'online',
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://voterstatus.sos.ca.gov',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2m2Vi4e',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '95814',
                city: 'Sacramento',
                state: 'CA',
                street: '1500 11th Street, 5th Floor',
                'routing-code': '95814',
              },
              'polling-place-url': 'https://voterstatus.sos.ca.gov',
              'polling-place-url-shortened': 'https://tvote.org/2m2Vi4e',
              'local-reg-authority-lookup-url':
                'http://www.sos.ca.gov/elections/voting-resources/county-elections-offices/',
              'local-election-authority-lookup-url':
                'http://www.sos.ca.gov/elections/voting-resources/county-elections-offices/',
            },
            {
              id: '57ed552a-b2d6-4bdd-83d1-8a5718acc3fa',
              email: 'akabsentee@alaska.gov',
              phone: '(907) 465-4611',
              types: ['election'],
              'office-name': 'Alaska',
              'homepage-url': 'http://www.elections.alaska.gov/',
              'ocd-division': [
                'ocd-division/country:us/state:ak',
                'Alaska',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will need to show ID to vote in Alaska. Acceptable forms of ID include: voter ID card; driver's license; state ID card; military ID card; passport; hunting or fishing license; or other current or valid photo ID. You may also present one of the following forms of ID if it includes your name and current address: current utility bill, bank statement, paycheck, government check or other government issued document.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a questioned ballot.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'ak_absentee' }],
                    },
                  ],
                  'election-authority-level': 'state',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          'You must provide one of the following identification numbers: Alaska Driver\'s License or Alaska State ID. If you do not have an Alaska Driver\'s License or Alaska State ID number, you must provide the last four digits of your Social Security number. If you do not have any of these identification numbers, please write "NONE" on the form. A unique identifying number will be assigned to you for voter registration purposes. This information is kept confidential. Having this information assists in maintaining your voter record and may assist in verifying your identity (Title 15 of the Alaska Statutes).',
                        signature:
                          'To register in Alaska you must: \nbe a citizen of the United States \nbe at least 18 years old within 90 days of completing this registration \nbe a resident of Alaska \nnot be a convicted felon (unless unconditionally discharged) \nnot be registered to vote in another State',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    {
                      url: 'https://voterregistration.alaska.gov/Registration/RegistrationDetails?haveValidAKDL=true',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need an Alaska ID and a Social Security number to use Alaska's online voter registration system. The address on the ID needs to match the address where you're registering to vote. If you don't have an Alaska-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://myvoterinformation.alaska.gov/',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2neXJBd',
                },
              ],
              'official-title': 'Division of Elections',
              'mailing-address': {
                zip: '99503-2838',
                city: 'Anchorage',
                state: 'AK',
                street: '2525 Gambell Street, Suite 105',
                'routing-code': '995032838',
              },
              'physical-address': {
                zip: '99801',
                city: 'Juneau',
                state: 'AK',
                street: 'Court Plaza Building, 240 Main Street, 4th Floor',
                'routing-code': '99801',
              },
              'polling-place-url': 'https://myvoterinformation.alaska.gov/',
              'polling-place-url-shortened': 'https://tvote.org/2neXJBd',
              'local-reg-authority-lookup-url':
                'http://www.elections.alaska.gov/Core/contactregionalelectionsoffices.php',
              'local-election-authority-lookup-url':
                'http://www.elections.alaska.gov/Core/contacttheabsenteeandpetitionoffice.php',
            },
            {
              id: '57ed552c-62e4-4cfc-8402-bf1170551a5f',
              email: 'nvelect@sos.nv.gov',
              phone: '775-684-5705',
              'office-name': 'Nevada',
              'homepage-url': 'https://www.nvsos.gov/sos/elections',
              'ocd-division': [
                'ocd-division/country:us/state:nv',
                'Nevada',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: false,
                      instructions: {
                        'voting-id':
                          "If you are a first time voter who would like to vote by mail, you must submit to your County Clerk/Registrar official identification of both IDENTITY and RESIDENCY with either your registration application or absent ballot request form.\n\nForms of ID may include (See NAC 293.395(2)): current and valid Nevada driver's license; current and valid ID card issued by the Department; current and valid identification card issued by a branch of the Armed Forces of the United States; current and valid identification card issued by a sheriff of a Nevada county to an employee as a condition of employment by certain business enterprises; current and valid identification card issued by an agency of the State of Nevada or political subdivision thereof or the United States, including, without limitation, a public school, college or university; current and valid student identification card from an accredited private school, college or university; current and valid United States passport; current and valid insurance plan identification card which the county clerk determines, in his or her discretion, to be a reliable indication of the true name and identity of the person; current and valid tribal identification card.\n\nArticles Establishing Residency may include (NAC 293.395(3)):any form of ID set forth above; current and valid utility bill, including, without limitation, a bill for electricity, gas, oil, water, sewer, septic, telephone, cellular telephone or cable television; current and valid bank or credit union statement; current and valid paycheck; current and valid income tax return; current and valid statement concerning mortgage, rental or lease of a residence; current and valid motor vehicle registration; current and valid document issued by a governmental agency; current and valid property tax statement; any other official article which the county clerk determines, in his or her discretion, to be a reliable indication of the true residential address of the person.",
                      },
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'nv_absentee' }],
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "If you've voted in Nevada before, you do not have to show ID to vote as long as your name appears in the election board register and your signature matches the signature on the record. \n\nIf you're a first-time voter, you must show ID to vote. Acceptable forms include: a current and valid photo identification, which shows physical address; or a copy of a current utility bill, bank statement, paycheck, or document issued by a governmental entity, including a check which indicates name and address.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "You must supply a Nevada driver's license number or Nevada ID card number if you have been issued one. If you do not have a driver's license number or Nevada ID card number, you must supply the last four digits of your Social Security number. If you do not have a Social Security number, please contact your County Clerk/Registrar of Voters to be assigned a unique identifier.",
                        signature:
                          'To register in Nevada you must: \nbe a citizen of the United States \nhave attained the age of 18 years on the date of the next election \nhave continuously resided in the State of Nevada, in your county, at least 30 days and in your precinct at least 10 days before the next election \nhave not been convicted of a felony, or if so convicted, have your voting rights restored automatically by operation of law or pursuant to a court order or pardon\nnot be determined by a court of law to be mentally incompetent \nclaim no other place as your legal residence',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    { type: 'election-day' },
                    {
                      url: 'https://www.nvsos.gov/sosvoterservices/Registration/Step0.aspx',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Nevada ID to use Nevada's online voter registration system. If you don't have a Nevada-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://nvsos.gov/votersearch/',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2nfaCLn',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '89701',
                city: 'Carson City',
                state: 'NV',
                street:
                  'Nevada State Capitol Building, 101 N Carson Street, Suite 3',
                'routing-code': '89701',
              },
              'polling-place-url': 'https://nvsos.gov/votersearch/index.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2nfaCLn',
              'local-reg-authority-lookup-url':
                'https://www.nvsos.gov/sos/elections/voters/county-clerk-contact-information',
              'local-election-authority-lookup-url':
                'https://www.nvsos.gov/sos/elections/voters/county-clerk-contact-information',
            },
            {
              id: '57ed552e-4150-40f2-a3d8-9b6603f186ac',
              email: 'elections@sos.wa.gov',
              phone: '(360) 902-4180',
              'office-name': 'Washington',
              'homepage-url': 'https://www.sos.wa.gov/elections/',
              'ocd-division': [
                'ocd-division/country:us/state:wa',
                'Washington',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: true,
                      'excuse-required': false,
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: false,
                      instructions: {
                        'voting-id':
                          'If you choose to appear in person to vote in Washington, it can be helpful to bring your driver’s license or state ID. If you do not have either, you can use the last four digits of your social security number to register or update your registration.',
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "You must provide your Washington driver's license or state ID card number. If you do not have a Washington driver's license or state ID card, you must provide the last four digits of your Social Security number. Failure to provide this information may prevent your registration from being processed.",
                        signature:
                          'To register in Washington you must: \nbe a citizen of the United States \nbe a legal resident of Washington State, your county and your precinct for 30 days immediately preceding the election in which you want to vote \nbe at least 18 years old by election day (16- and 17-year-olds can sign up as Future Voters and be automatically registered to vote when they turn 18)\nnot be under Department of Corrections supervision for a Washington felony conviction',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    {
                      url: 'https://olvr.votewa.gov/',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Washington ID to use Washington's online voter registration system. If you don't have a Washington-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://www.sos.wa.gov/elections/myvote/',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2neYBWt',
                },
              ],
              'official-title': 'Secretary of State',
              'mailing-address': {
                zip: '98504-0229',
                city: 'Olympia',
                state: 'WA',
                street: 'PO BOX 40229',
                'routing-code': '985040229',
              },
              'physical-address': {
                zip: '98501',
                city: 'Olympia',
                state: 'WA',
                street: '520 Union Avenue SE',
                'routing-code': '98501',
              },
              'polling-place-url':
                'https://voter.votewa.gov/WhereToVote.aspx#/login',
              'polling-place-url-shortened': 'https://tvote.org/2mGHyhR',
              'local-reg-authority-lookup-url':
                'https://www.sos.wa.gov/elections/auditors.aspx',
              'local-election-authority-lookup-url':
                'https://www.sos.wa.gov/elections/auditors.aspx',
            },
            {
              id: '57ed552e-4908-41b8-b463-93d50a3f495f',
              email: 'elections@elections.sc.gov',
              phone: '(803) 734-9060',
              'office-name': 'South Carolina',
              'homepage-url': 'https://www.scvotes.org/',
              'ocd-division': [
                'ocd-division/country:us/state:sc',
                'South Carolina',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will be asked to show photo ID to vote in South Carolina. Acceptable forms include: South Carolina driver's license or South Carolina Department of Motor Vehicles ID Card; South Carolina Concealed Weapons Permit; South Carolina voter registration card with photo; US military ID (Includes all Department of Defense Photo IDs and Veterans Affairs Benefits Card); or US passport (Includes US Passport ID Card).\n\nVoters without ID: If you have a reasonable impediment to obtaining photo ID, you may vote a provisional ballot after showing your non-photo voter registration card. If you do not have photo ID and do not have a reasonable impediment to obtaining one, or you simply forgot to bring it with you to the polls, you may still vote a provisional ballot. However, for your vote to be counted, you must provide one of the photo IDs to the election commission prior to certification of the election (usually Thursday or Friday after the election).",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': true,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        race: 'You are required to fill in this box. Your application may be rejected if you fail to do so.',
                        idnumber:
                          'Your full Social Security number is required. It is required by the South Carolina Code of Laws and is used for internal purposes only. Social Security number does not appear on any report produced by the State Election Commission nor is it released to any unauthorized individual. (South Carolina Title 7-5-170)',
                        signature:
                          'To register in South Carolina you must: \nbe a citizen of the United States \nbe at least 18 years old on or before the next election \nbe a resident of South Carolina, your county and precinct \nnot be confined in any public prison resulting from a conviction of a crime \nnever have been convicted of a felony or offense against the election laws, or if previously convicted, have served your entire sentence, including probation or parole, or have received a pardon for the conviction \nnot be under a court order declaring you mentally incompetent \nclaim the address on the application as your only legal place of residence and claim no other place as your legal residence',
                      },
                      'acceptable-forms': [
                        { name: 'nvrf', fields: { race: 'required' } },
                      ],
                    },
                    {
                      url: 'https://info.scvotes.sc.gov/eng/ovr/start.aspx',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a South Carolina driver's license or DMV ID card to use the online voter registration system. The address on record at the DMV needs to match the address where you're registering to vote, this can be updated online. If you don't have the correct ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://info.scvotes.sc.gov/eng/voterinquiry/VoterInformationRequest.aspx',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mjB4Et',
                },
              ],
              'official-title': 'State Election Commission',
              'physical-address': {
                zip: '29201',
                city: 'Columbia',
                state: 'SC',
                street: '1122 Lady Street, Suite 500',
                'routing-code': '29201',
              },
              'polling-place-url':
                'https://info.scvotes.sc.gov/eng/voterinquiry/VoterInformationRequest.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2mjB4Et',
              'local-reg-authority-lookup-url':
                'https://www.scvotes.org/how-register-absentee-voting',
              'local-election-authority-lookup-url':
                'https://www.scvotes.org/how-register-absentee-voting',
            },
            {
              id: '57ed552b-80e5-4b15-9d33-808d27e3a7de',
              email: 'elections@iec.in.gov',
              phone: '317-232-3939',
              'office-name': 'Indiana',
              'homepage-url': 'https://indianavoters.in.gov/',
              'ocd-division': [
                'ocd-division/country:us/state:in',
                'Indiana',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will need to show photo ID to vote in Indiana. Your photo ID must display your name, an expiration date (can be current or expired sometime after Nov 6, 2018), and be issued by the State of Indiana or the US government. Acceptable forms include: Indiana driver's license or Indiana-issued photo ID card; military ID; or US Passport. A student ID from an Indiana State school may be used if it meets the above requirements. A student ID from a private institution may not be used for voting purposes.\n\nIf you're a first-time voter who registered by mail, you will also need to provide proof of residence to vote. Acceptable forms include (must show current name and current address): Indiana driver's license or Indiana-issued ID card; any current and valid photo ID; or a current utility bill, bank statement, government check, paycheck, or other government document.\n\nVoters without ID: If you are unable or unwilling to present ID meeting these requirements, you may cast a provisional ballot. If you cast a provisional ballot, you have until noon 10 days after the election to follow up with the county election board and either provide the necessary documentation or affirm one of the law’s exemptions applies to you.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      instructions: {
                        'voting-id':
                          'If you are voting for the first time in Indiana, you should submit proof of residency with your absentee ballot request. Acceptable proof includes: current and valid photo ID; or a current utility bill, bank statement, government check, paycheck, or other government document that shows your name and address.',
                      },
                      'excuse-required': true,
                      'acceptable-forms': [{ name: 'in_absentee' }],
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      url: 'https://indianavoters.in.gov/',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need an Indiana ID to use Indiana's online voter registration system. If you don't have an Indiana-issued ID, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "Your state voter ID number is your ten-digit Indiana-issued driver's license number. If you do not possess an Indiana driver's license then provide the last four digits of your Social Security number. If you do not have a Social Security number, then a voter ID number will be assigned to you. Please indicate which number was provided or write “none” if you do not have an Indiana driver’s license or Social Security number. (Indiana Code 3-7-13-13)",
                        signature:
                          'To register in Indiana you must: \nbe a citizen of the United States \nhave resided in the precinct at least 30 days before the next election \nbe at least 18 years of age on the day of the next general election \nnot currently be imprisoned following a criminal conviction',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://indianavoters.in.gov/',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2uKAc3z',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '46204',
                city: 'Indianapolis',
                state: 'IN',
                street: '302 W. Washington St., Rm E204',
                'routing-code': '46204',
              },
              'polling-place-url': 'https://indianavoters.in.gov/',
              'polling-place-url-shortened': 'https://tvote.org/2uKAc3z',
              'local-reg-authority-lookup-url':
                'https://indianavoters.in.gov/CountyContact/Index',
              'local-election-authority-lookup-url':
                'https://indianavoters.in.gov/CountyContact/Index',
            },
            {
              id: '57ed552c-ad86-4d10-ba3d-6e326ebcce27',
              email: 'secretary.state@state.mn.us',
              phone: '877-600-8683',
              'office-name': 'Minnesota',
              'homepage-url': 'https://www.sos.state.mn.us/elections-voting/',
              'ocd-division': [
                'ocd-division/country:us/state:mn',
                'Minnesota',
                {
                  'voting-methods': [
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You do not need to show ID to vote in Minnesota if your voter registration is current and active.\n\nIf you're voting for the first time in Minnesota, you will have to show ID to vote if you registered by mail and your ID number could not be verified by the state, or if you are registering to vote on Election Day. Acceptable forms include: a valid ID with current name and address (e.g. driver's license, Minnesota ID card, learner's permit, US passport, student ID from a Minnesota high school, college, or technical school, or a tribal ID card with name, address, photo and signature); a photo ID and a document with current name and address (e.g. utility bill, bank or credit card statement, mortgage or lease; can be shown on electronic device); a registered voter from your precinct who can confirm your name and address; notice of late registration; valid registration in the same precinct; college student ID (if a student housing list is provided); or a staff person of a residential facility.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'mn_absentee' }],
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          'You are required to provide your Minnesota driver\'s license or state ID number to register to vote. If you do not have a Minnesota driver\'s license or state ID then you will have to provide the last four digits of your Social Security number. If you have neither, please write "none" on the form.',
                        signature:
                          'To register in Minnesota you must: \nbe a citizen of the United States \nbe a resident of Minnesota for 20 days before the next election \nmaintain residence at the address given on the registration form \nbe at least 18 years old on election day \nif previously convicted of a felony, your felony sentence has expired or been completed, or you have been discharged from the sentence \nnot be under a court-ordered guardianship in which the right to vote has been revoked \nnot be found by a court to be legally incompetent to vote',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    { type: 'election-day' },
                    {
                      url: 'https://mnvotes.sos.state.mn.us/VoterRegistration/VoterRegistrationMain.aspx',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need either a Minnesota ID or the last four digits of your Social Security number and an email address to use Minnesota's online voter registration system. If you don't have either form of ID and an email address, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                  ],
                  'voter-registration-status-url':
                    'https://mnvotes.sos.state.mn.us/VoterStatus.aspx',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2nffrEz',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '55155',
                city: 'St. Paul',
                state: 'MN',
                street:
                  '180 State Office Building, 100 Rev. Dr. Martin Luther King Jr. Blvd',
                'routing-code': '55155',
              },
              'polling-place-url': 'https://pollfinder.sos.state.mn.us/',
              'polling-place-url-shortened': 'https://tvote.org/2n6S6Wp',
              'local-reg-authority-lookup-url':
                'https://www.sos.state.mn.us/elections-voting/find-county-election-office/',
              'local-election-authority-lookup-url':
                'https://www.sos.state.mn.us/elections-voting/find-county-election-office/',
            },
            {
              id: '57ed552a-da7e-4846-aec9-ae52110997e1',
              email: 'DivElections@dos.myflorida.com',
              phone: '(850) 245-6500',
              'office-name': 'Florida',
              'homepage-url': 'http://dos.myflorida.com/elections/',
              'ocd-division': [
                'ocd-division/country:us/state:fl',
                'Florida',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'fl_absentee' }],
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will be asked to show a valid photo ID with signature to vote in Florida. Acceptable forms include: Florida driver's license or ID card issued by the Department of Highway Safety and Motor Vehicles; US passport; debit or credit card; military ID; student ID; retirement center ID; neighborhood association ID; public assistance ID; veteran health ID; license to carry a concealed weapon or firearm; or an employee ID card issued by the federal government, the state of Florida, or any county or municipality. If your photo ID does not include your signature, you will be asked to provide another ID that has your signature.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot. Your ballot will count if the signature on your ballot matches the signature on your voter registration record.",
                      },
                      'excuse-required': false,
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      url: 'https://registertovoteflorida.gov/eligibilityreactive',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you need a Florida ID and a Social Security number to use Florida's online voter registration system. The name and address on the ID must match your voter registration exactly, so you should plan to have your ID on hand. If you don't have a Florida-issued ID, or don’t have your Florida-issued ID on hand, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                    {
                      type: 'by-mail',
                      instructions: {
                        race: 'You are requested, but not required, to fill in this box.',
                        idnumber:
                          'If you have one, you must provide your Florida driver\'s license number or Florida identification card number. If you do not have a Florida driver\'s license or identification card, you must provide the last four digits of your Social Security number. If you have not been issued any of these numbers, you must write the word "NONE".',
                        signature:
                          'To register in Florida you must: \nbe a citizen of the United States \nbe a legal resident of both the State of Florida and of the county in which you seek to be registered \nbe 18 years old (you may pre-register if you are at least 16) \nnot be adjudicated mentally incapacitated with respect to voting in Florida or any other State, or if you have, you must first have your voting rights restored\nnot be a convicted felon, or if you are, you must first have your civil rights restored if they were taken away\nswear or affirm the following: "I will protect and defend the Constitution of the United States and the Constitution of the State of Florida, that I am qualified to register as an elector under the Constitution and laws of the State of Florida, and that all information in this application is true."',
                      },
                      'acceptable-forms': [
                        { name: 'nvrf', fields: { race: 'requested' } },
                      ],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://registration.elections.myflorida.com/CheckVoterStatus',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2lZ6ONw',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '32399',
                city: 'Tallahassee',
                state: 'FL',
                street: 'R.A. Gray Building, 500 South Bronough Street',
                'routing-code': '32399',
              },
              'polling-place-url':
                'https://registration.elections.myflorida.com/CheckVoterStatus',
              'polling-place-url-shortened': 'https://tvote.org/2lZ6ONw',
              'local-reg-authority-lookup-url':
                'http://dos.elections.myflorida.com/supervisors/',
              'local-election-authority-lookup-url':
                'http://dos.elections.myflorida.com/supervisors/',
            },
            {
              id: '57ed552a-587e-4783-82fb-f5c5341a2990',
              email: 'electionsemail@sos.arkansas.gov',
              phone: '(501) 682-5070',
              'office-name': 'Arkansas',
              'homepage-url': 'https://www.sos.arkansas.gov/elections',
              'ocd-division': [
                'ocd-division/country:us/state:ar',
                'Arkansas',
                {
                  'voting-methods': [
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': true,
                      'acceptable-forms': [{ name: 'ar_absentee' }],
                    },
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "You will need to show ID to vote in Arkansas. Acceptable forms of ID include: an Arkansas driver’s license; an Arkansas photo identification card; a concealed handgun carry license; a United States passport; an employee badge or identification document issued by an accredited postsecondary education institution in the State of Arkansas; a United States military identification document; a public assistance identification card if the card shows a photograph of the person to whom the document or identification card was issued; a voter verification card.\n\nIf you're voting for the first-time in Arkansas, registered to vote by mail, and didn't submit a copy of your ID when you registered, you will need to show ID to vote. Acceptable forms include: a driver's license or non-driver's license ID; or a current utility bill, bank statement, government check, paycheck, or other government document with your name and address. \n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "Your completed voter registration form must contain your state-issued driver's license number or nonoperating identification number. If you do not have a driver's license or nonoperating identification, you must include the last four digits of your Social Security number. If you do not have a driver's license or a nonoperating identification or a Social Security number, please write \"NONE\" on the form. A unique identifying number will be assigned by the State.",
                        signature:
                          'To register in Arkansas you must: \nbe a citizen of the United States \nlive in Arkansas at the address on your voter registration application \nbe at least 18 years old before the next election \nnot be a convicted felon (or have completely discharged your sentence or been pardoned) \nnot claim the right to vote in any other jurisdiction \nnot previously be adjudged mentally incompetent by a court of competent jurisdiction',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://www.voterview.ar-nova.org/VoterView/RegistrantSearch.do',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mGrDBv',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '72201',
                city: 'Little Rock',
                state: 'AR',
                street:
                  'Executive Office State Capitol, Suite 256, 500 Woodlane Avenue',
                'routing-code': '72201',
              },
              'polling-place-url':
                'https://www.voterview.ar-nova.org/VoterView/PollingPlaceSearch.do',
              'polling-place-url-shortened': 'https://tvote.org/2LXyfsF',
              'local-reg-authority-lookup-url':
                'https://www.sos.arkansas.gov/uploads/elections/ARCountyClerks.pdf',
              'local-election-authority-lookup-url':
                'https://www.sos.arkansas.gov/uploads/elections/Arkansas%20County%20Clerks%20-%20Revised%20September%202016.pdf',
            },
            {
              id: '57ed552c-7946-4960-84c5-8fb516f0e39d',
              email: 'info@elections.ny.gov',
              phone: '800-367-8683',
              'office-name': 'New York',
              'homepage-url': 'https://www.elections.ny.gov/',
              'ocd-division': [
                'ocd-division/country:us/state:ny',
                'New York',
                {
                  'voting-methods': [
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': true,
                      'acceptable-forms': [{ name: 'ny_absentee' }],
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "If you've voted in New York before, you don't need to provide ID to vote.\n\nIf you're a first-time voter who registered by mail, and didn't provide a copy of your ID with your registration, you may need to show ID to vote. Acceptable forms include: a current and valid photo ID; or a copy of a current utility bill, bank statement, government check, paycheck, or other government document that shows your name and address.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote an affidavit ballot.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'county',
                  'voter-registration-methods': [
                    {
                      url: 'https://voterreg.dmv.ny.gov/MotorVoter/',
                      type: 'online',
                      instructions: {
                        registration:
                          "You should know: you don't need a driver's license to register in New York, but you do need one to register online along with a social security number, and the address listed on your ID needs to match where you’re registering to vote. If you don't have a New York-issued ID, or prefer to register at a different address, you can still register to vote by mail.",
                      },
                      'supports-iframe': false,
                    },
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          'Federal law requires that you provide your driver\'s license number to register to vote. If you do not have a driver\'s license then you will have to provide at least the last four digits of your Social Security number. If you have neither, please write "NONE" on the form. A unique identifying number will be assigned to you by your State.',
                        signature:
                          'To register in New York you must: \nbe a citizen of the United States  \nbe a resident of the county, or of the City of New York, at least 30 days before an election \nbe 18 years old by December 31 of the year in which you file this form (Note: You must be 18 years old by the date of the general, primary, or other election in which you want to vote) \nnot be in jail or on parole for a felony conviction (unless parolee pardoned or restored rights of citizenship)\nnot currently be judged incompetent by order of a court of competent judicial authority \nnot claim the right to vote elsewhere',
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                  ],
                  'voter-registration-status-url':
                    'https://voterlookup.elections.ny.gov/',
                  'voter-registration-authority-level': 'county',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2FGrmZr',
                },
              ],
              'official-title': 'State Board of Elections',
              'physical-address': {
                zip: '12207',
                city: 'Albany',
                state: 'NY',
                street: '40 North Pearl Street, Suite 5',
                'routing-code': '12207',
              },
              'polling-place-url':
                'https://voterlookup.elections.ny.gov/votersearch.aspx',
              'polling-place-url-shortened': 'https://tvote.org/2LwyVEl',
              'local-reg-authority-lookup-url':
                'https://www.elections.ny.gov/CountyBoards.html',
              'local-election-authority-lookup-url':
                'https://www.elections.ny.gov/CountyBoards.html',
            },
            {
              id: '57ed552e-77cb-4c9d-aa81-571521fb748a',
              email: 'sos.elections@sec.state.vt.us',
              phone: '800-439-8683',
              'office-name': 'Vermont',
              'homepage-url': 'https://www.sec.state.vt.us/elections.aspx',
              'ocd-division': [
                'ocd-division/country:us/state:vt',
                'Vermont',
                {
                  'voting-methods': [
                    {
                      type: 'early-voting',
                      primary: false,
                      'excuse-required': false,
                    },
                    {
                      type: 'by-mail',
                      primary: false,
                      'excuse-required': false,
                      'acceptable-forms': [{ name: 'vt_absentee' }],
                    },
                    {
                      type: 'in-person',
                      primary: true,
                      instructions: {
                        'voting-id':
                          "If you've voted in Vermont before, you do not need to show ID to vote.\n\nIf you're a first-time voter in the municipality who registered by mail, and didn't provide ID when you registered, you will need to show ID to vote. Acceptable forms include: a valid photo ID; or a copy of a current utility bill, bank statement, government check, paycheck, or any other government document that shows your current name and address.\n\nVoters without ID: If you are unable to provide ID, you will be able to vote a provisional ballot.",
                      },
                      'excuse-required': false,
                    },
                  ],
                  'election-authority-level': 'municipal',
                  'voter-registration-methods': [
                    {
                      type: 'by-mail',
                      instructions: {
                        idnumber:
                          "You must provide your Vermont driver's license number, or if none, the last 4 digits of your Social Security number. If you do not have a Vermont driver's license or a Social Security number, please write \"NONE\" on the form. The Secretary of State's office will assign you a unique identifying number.",
                        signature:
                          "To register in Vermont you must: \nbe a citizen of the United States \nbe a resident of Vermont \nbe 18 years of age on or before election day \nhave taken the following Oath: You solemnly swear (or affirm) that whenever you give your vote or suffrage, touching any matter that concerns the state of Vermont, you will do it so as in your conscience you shall judge will most conduce to the best good of the same, as established by the Constitution, without fear or favor of any person [Voter's Oath, Vermont Constitution, Chapter II, Section 42]\nBy signing, you are attesting that you have sworn or affirmed the Vermont voter's oath as printed above. The oath may be self-administered.",
                      },
                      'acceptable-forms': [{ name: 'nvrf' }],
                    },
                    {
                      url: 'https://www.olvr.sec.state.vt.us/',
                      type: 'online',
                      instructions: {
                        registration:
                          'The Vermont online voter registration system is accesible to all Vermont voters.',
                      },
                      'supports-iframe': false,
                    },
                    { type: 'election-day' },
                  ],
                  'voter-registration-status-url':
                    'https://mvp.sec.state.vt.us/',
                  'voter-registration-authority-level': 'municipal',
                  'voter-registration-status-url-shortened':
                    'https://tvote.org/2mjxtWU',
                },
              ],
              'official-title': 'Secretary of State',
              'physical-address': {
                zip: '05633',
                city: 'Montpelier',
                state: 'VT',
                street: '128 State Street',
                'routing-code': '05633',
              },
              'polling-place-url': 'https://mvp.sec.state.vt.us/',
              'polling-place-url-shortened': 'https://tvote.org/2mjxtWU',
              'local-reg-authority-lookup-url':
                'https://www.sec.state.vt.us/media/686155/TownClerkGuide.pdf',
              'local-election-authority-lookup-url':
                'https://www.sec.state.vt.us/media/686155/TownClerkGuide.pdf',
            },
          ],
        },
      },
    },
  ],
};
